import { NodeCell, ElementPropertyConfig, FarrisPropConfigWithData } from "@edp-pmf/grapheditor";
import { MxGraphNS, mxResources } from "@edp-pmf/mxgraph-ts";
import { BpmnModelHelper, BPMNShape, Expression, FlowNodeState, MultiInstanceLoopCharacteristics } from "@edp-pmf/bpmn-model";
import { BizActivity, OtherAssignNodes, UserActivity, OperationActivity, StartActivity, UrgeHandleRule, ApprovalPivot, ApprovalPivotConfig, ImageSettings, CheckCondition, VariableSetting, CustomizeAction, DurationType, TimeLimitControl, Tool, TitleExpression, JumpScope, BackWardRule, CounterSignRule, ParticipantSetting, AssignPerformerConfig, Component, ConclusionItem, ExecuteWorkItemMode, WorkFlowAction, DisplayTerminal, AssignmentStrategy, TimeLimitControlInfo, SendMessageExpireOperation, SendMessageExpireOperationInfo, AutoHandleExpireOperation, AutoHandleExpireOperationInfo, ExtendProperty, MessageNotice, ActionScope, Condition, ExecuteForm, PotentialOwnerImpl, HumanPerformerImpl, OrganizationParticipantExpression, VariableParticipantExpression, ComponentParticipantExpression, ReportingLineParticipantExpression, MatrixParticipantExpression, ParticipantExpression, ActivityExecutorParticipantExpression, UserParticipantExpression, PositionParticipantExpression, ActualParameter, ActionOrganizationScope, SmsMessageTemplate, SmsMessageVariable, OtherAssignActivityNodeInfo, OrganizationLevel, SemanticExpression} from "@gsp-wf/wf-process-model";
import { PropertyHelper } from "./PropertyHelper";
import { WfEditorUi } from "../WfEditorUi";
import { UserParticipant } from "../entity/UserParticipant";
import { PositionParticipant } from "../entity/PositionParticipant";
import { VariablePerformer } from "../entity/VariablePerformer";
import { ComponentParticipant } from "../entity/ComponentParticipant";
import { ReportingLineParticipant } from "../entity/ReportingLineParticipant";
import { ActivityExecutorParticipant } from "../entity/ActivityExecutorParticipant";
import { MatrixParticipant } from "../entity/MatrixParticipant";
import { AssignConfig } from "../entity/AssignConfig";
import { AssignStrategy } from "../entity/AssignStrategy";
import { OrganizationParticipant } from "../entity/OrganizationParticipant";
import { WfConstants } from "../WfConstants";
import { UserActivityPropertyKeys } from "./property-keys/UserActivityPropertyKeys";
import { WfDesignerUtils } from "../WfDesignerUtils";
import { MessagerService } from '@farris/ui-messager';
import { ActionOrganizationScopeDesign, OrganizationPotentialOwner } from "../../views/organization-potential-owner/actionOrganizationScope";
// import { ParticipantInfo } from "../../views/participant/participant.info";
import { Participant, ParticipantInfo } from "../entity";

/**
 * 审批活动节点
 */
export class UserActivityCell extends NodeCell {
    clrTypeId: string = UserActivityCell.CLR_TYPE_ID;
    name: string = "审批";
    nameLanguage: { [lang: string]: string; } = {
      "zh-CHS": "审批",
      "zh-CHT": "審批",
      "en": "Approve",
  };
    static CLR_TYPE_ID: string = UserActivity.Clr_Type_ID;
    flowElement: UserActivity;
    editorUi: WfEditorUi;

    imgUrls = {
        [FlowNodeState.Default]: WfConstants.IMAGE_PATH + "/approval.png",
        [FlowNodeState.Selected]: WfConstants.IMAGE_PATH + "/approval_select.svg",
    };

    bizActivity: BizActivity;

    constructor(value?: any, geometry?: MxGraphNS.mxGeometry, style?: string) {
        super(value, geometry, style);
    }

    createFlowElement(flowElt?: UserActivity) {
        const flowNode = super.createFlowElement(flowElt) as UserActivity;
        const editorUi = this.editorUi;
        const bpmnModel = editorUi.graph.bpmnModel;
        flowNode.Id = "UserActivity" + BpmnModelHelper.GenerateElementId();

        if(flowNode && flowNode.anonymousText) {
            if(editorUi) {
                if(editorUi.langCode === 'zh-CHS') {
                    flowNode.anonymousText = '办理人';
                }else if(editorUi.langCode === 'en') {
                    flowNode.anonymousText = 'Handler';
                }else {
                    flowNode.anonymousText = '辦理人';
                }
            }
        }

        // 创建而非复制时执行
        if (flowElt == null) {
            flowNode.transferAble = editorUi.generalConfig.enableTransfer;
            flowNode.AddSignBehindAble = editorUi.generalConfig.enableAddSignBehind;
            flowNode.AddSignFrontAble = editorUi.generalConfig.enableAddSignFront;
            flowNode.NotifyAble = editorUi.generalConfig.enableNotify;

            if (this.bizActivity) {
                const bizActivity = this.bizActivity;
                flowNode.BizActivityID = bizActivity.id;
                flowNode.BizActivityName = bizActivity.name;
                flowNode.Tools = [];
                for (let c of bizActivity.bizComponents) {
                    let tool = new Component(flowNode.Model);
                    tool.Id = c.id
                    tool.Name = c.name;
                    tool.Time = c.executionTime;
                    // TODO 写死了构件类型
                    tool.ComponentType = 'CommonComponent';
                    tool.MetadataId = c.metadataId;
                    tool.MethodCode = c.methodCode;
                    tool.ActualParameters = [];
                    if (c.actualParameters && (c.actualParameters as any[]).length > 0) {
                        for (let a of (c.actualParameters as any[])) {
                            let parameter = new ActualParameter(bpmnModel, a.code, a.value);
                            tool.ActualParameters.push(parameter);
                        }
                    }
                    flowNode.Tools.push(tool);
                }
                flowNode.setBizConclusions(bpmnModel, bizActivity.bizActions);
            } else {
                flowNode.BizActivityID = "";
                flowNode.initConclusions(bpmnModel, editorUi.langCode);
            }
        }

        return flowNode;
    }

    createDiagramElement(): BPMNShape {
        if (this.bizActivity != null) {
            this.imgUrls = {
                [FlowNodeState.Default]: WfConstants.IMAGE_PATH + "/bizActivity.png",
                [FlowNodeState.Selected]: WfConstants.IMAGE_PATH + "/bizActivity_select.svg",
            };
        }

        const shape = super.createDiagramElement();
        return shape;
    }

    getFarrisPropConfig(): FarrisPropConfigWithData {
        return this.getFarrisPropConfigByIsOperation();
    }

    getFarrisPropConfigByIsOperation(isOperation: boolean = false) {
        const editorUi = this.editorUi;
        let extendList = [];
        if (editorUi.procExtProps && editorUi.procExtProps.length > 0) {
            extendList = JSON.parse(JSON.stringify(editorUi.procExtProps)).sort((a, b) => {
                return a.sortOrder - b.sortOrder;
            });
        }
        extendList = extendList.sort((a, b) => {
            return a.sortOrder - b.sortOrder;
        })

        let userAct = this.flowElement;
        let basicProperty: ElementPropertyConfig = new ElementPropertyConfig();
        let propertyData: any = {};

        basicProperty.categoryId = 'basicProperty';
        basicProperty.categoryName = mxResources.get('basicInformation');
        basicProperty.tabId = 'basic';
        basicProperty.tabName = mxResources.get('basicAttributes')
        basicProperty.properties = [
            { propertyID: UserActivityPropertyKeys.Name, propertyName: mxResources.get('name'), propertyType: 'string', visible: !this.editorUi.multiLangEnabled },
            { propertyID: UserActivityPropertyKeys.NameLanguage, propertyName: mxResources.get('nameLanguage'), propertyType: 'multiLanguage', visible: this.editorUi.multiLangEnabled },
            { propertyID: UserActivityPropertyKeys.Id, propertyName: mxResources.get('id'), propertyType: 'string', readonly: true },
            { propertyID: UserActivityPropertyKeys.wf_TitleExpression, propertyName: mxResources.get('wfTitleExpression'), propertyType: 'modal' },
        ];

        let performerProperty: ElementPropertyConfig = new ElementPropertyConfig();
        performerProperty.categoryId = 'performerProperty';
        performerProperty.categoryName = mxResources.get('participant');
        performerProperty.tabId = 'basic';
        performerProperty.tabName = mxResources.get('basicAttributes')
        performerProperty.properties = [
            { propertyID: UserActivityPropertyKeys.ParticipantSchemes, propertyName: mxResources.get('participantSchemes'), propertyType: 'modal' },
            { propertyID: UserActivityPropertyKeys.ParticipantOptions, propertyName: mxResources.get('participantOptions'), propertyType: 'modal' },
        ];
        // if (userAct.AssignmentStrategy !== AssignmentStrategy.ASSIGN) {
        //     performerProperty.properties.push(
        //         { propertyID: UserActivityPropertyKeys.AssignStrategy, propertyName: '分配策略', propertyType: 'modal' }
        //     );
        // } else {
        //     performerProperty.properties = performerProperty.properties.concat(
        //         [{ propertyID: UserActivityPropertyKeys.AssignStrategy, propertyName: '分配策略', propertyType: 'modal' },
        //         { propertyID: UserActivityPropertyKeys.AssignPerformer, propertyName: '备选办理人', propertyType: 'modal' }]);
        // }
        if (!isOperation) {
            if (userAct.ExecuteWorkItemMode === ExecuteWorkItemMode.Preempt) {
                performerProperty.properties.push(
                    { propertyID: UserActivityPropertyKeys.CompleteStrategy, propertyName: mxResources.get('completeStrategy'), propertyType: 'select' },
                );
                propertyData[UserActivityPropertyKeys.CompleteStrategy] = userAct.ExecuteWorkItemMode;
            } else {
                performerProperty.properties = performerProperty.properties.concat([
                    { propertyID: UserActivityPropertyKeys.CompleteStrategy, propertyName: mxResources.get('completeStrategy'), propertyType: 'select' },
                    { propertyID: UserActivityPropertyKeys.SignRule, propertyName: mxResources.get('signRule'), propertyType: 'modal' },
                ]);
                propertyData[UserActivityPropertyKeys.CompleteStrategy] = userAct.ExecuteWorkItemMode;
                propertyData[UserActivityPropertyKeys.SignRule] = userAct.CounterSignRules;
            }
        }

        let approvalProperty: ElementPropertyConfig = new ElementPropertyConfig();
        approvalProperty.categoryId = 'approvalProperty';
        approvalProperty.categoryName = mxResources.get('operationsManage');
        approvalProperty.tabId = 'approvalProperty';
        approvalProperty.tabName = mxResources.get('operationsConfig');
        approvalProperty.properties = [
            { propertyID: UserActivityPropertyKeys.ApprovalItems, propertyName: mxResources.get('approvalItems'), propertyType: 'modal' },
            { propertyID: UserActivityPropertyKeys.wf_CustomizeAction, propertyName: mxResources.get('wfCustomizeAction'), propertyType: 'modal' },
        ];
        // 审批活动节点含“驳回”审批动作时，属性框支持驳回规则属性
        if (userAct.Conclusions && this.isBackConclusionExist(userAct.Conclusions)) {
            approvalProperty.properties.push(
                { propertyID: UserActivityPropertyKeys.BackWardRule, propertyName: mxResources.get('backWardRule'), propertyType: 'modal' },
            );
            propertyData[UserActivityPropertyKeys.BackWardRule] = userAct.BackWardRule;
        }
        approvalProperty.properties = approvalProperty.properties.concat([
            { propertyID: UserActivityPropertyKeys.Retrievable, propertyName: mxResources.get('retrievable'), propertyType: 'select' },
        ]);
        if (!isOperation) {
            approvalProperty.properties = approvalProperty.properties.concat([
                { propertyID: UserActivityPropertyKeys.AddSignFrontAble, propertyName: mxResources.get('addSignFrontAble'), propertyType: 'modal' },
                { propertyID: UserActivityPropertyKeys.AddSignBehindAble, propertyName: mxResources.get('addSignBehindAble'), propertyType: 'modal' },
            ]);
        }
        if (editorUi.generalConfig.enableTransfer) {
            approvalProperty.properties = approvalProperty.properties.concat([
                { propertyID: UserActivityPropertyKeys.transferScope, propertyName: mxResources.get('transferScope'), propertyType: 'modal' },
            ]);
        }
        approvalProperty.properties = approvalProperty.properties.concat([
            { propertyID: UserActivityPropertyKeys.NotifyAble, propertyName: mxResources.get('notifyAble'), propertyType: 'modal' },
            { propertyID: UserActivityPropertyKeys.urgeHandleRule, propertyName: mxResources.get('urgeHandleRule'), propertyType: 'modal' }
        ]);
        if (userAct.SelectTargetAble) {
            approvalProperty.properties = approvalProperty.properties.concat([
                { propertyID: UserActivityPropertyKeys.SelectTargetAble, propertyName: mxResources.get('selectTargetAble'), propertyType: 'select' },
                { propertyID: UserActivityPropertyKeys.JumpScope, propertyName: mxResources.get('jumpScope'), propertyType: 'modal' },
            ]);
            propertyData[UserActivityPropertyKeys.SelectTargetAble] = userAct.SelectTargetAble;
            propertyData[UserActivityPropertyKeys.JumpScope] = userAct.JumpScope;
        } else {
            approvalProperty.properties = approvalProperty.properties.concat([
                { propertyID: UserActivityPropertyKeys.SelectTargetAble, propertyName: mxResources.get('selectTargetAble'), propertyType: 'select' },
            ]);
            propertyData[UserActivityPropertyKeys.SelectTargetAble] = userAct.SelectTargetAble;
        }

        if (userAct.otherAssignNodes) {
            approvalProperty.properties = approvalProperty.properties.concat([
                { propertyID: UserActivityPropertyKeys.otherAssignNodes, propertyName: mxResources.get('otherAssignNodes'), propertyType: 'select' },
                // { propertyID: UserActivityPropertyKeys.otherAssignActivities, propertyName: mxResources.get('otherAssignActivities'), propertyType: 'modal' },
                { propertyID: UserActivityPropertyKeys.otherAssignActivityNodeInfos, propertyName: mxResources.get('otherAssignActivityNodeInfos'), propertyType: 'modal' },
            ]);
            propertyData[UserActivityPropertyKeys.otherAssignNodes] = true;
            // propertyData[UserActivityPropertyKeys.otherAssignActivities] = userAct.otherAssignNodes.otherAssignActivities;
            propertyData[UserActivityPropertyKeys.otherAssignActivityNodeInfos] = userAct.otherAssignNodes.otherAssignActivityNodeInfos || userAct.otherAssignNodes.otherAssignActivityNodeInfos;
            if(userAct.otherAssignNodes.otherAssignActivities){
                userAct.otherAssignNodes.otherAssignActivities = null;
            }

        } else {
            approvalProperty.properties = approvalProperty.properties.concat([
                { propertyID: UserActivityPropertyKeys.otherAssignNodes, propertyName: mxResources.get('otherAssignNodes'), propertyType: 'select' }
            ]);
            propertyData[UserActivityPropertyKeys.otherAssignNodes] = false;
        }

        let eventListeners: ElementPropertyConfig = new ElementPropertyConfig();
        eventListeners.categoryId = 'eventListeners';                                                      // 活动选项（表单定义+活动构件）
        eventListeners.categoryName = mxResources.get('eventListeners');
        eventListeners.tabId = 'advanced';
        eventListeners.tabName = mxResources.get('advancedAttributes');
        eventListeners.properties = [
            { propertyID: UserActivityPropertyKeys.Tools, propertyName: mxResources.get('tools'), propertyType: 'modal' },
            { propertyID: UserActivityPropertyKeys.checkConditions, propertyName: mxResources.get('checkConditions'), propertyType: 'modal' },
            { propertyID: UserActivityPropertyKeys.variableSettings, propertyName: mxResources.get('variableSettings'), propertyType: 'modal' }
        ];

        let ApprovalSettings: ElementPropertyConfig = new ElementPropertyConfig();
        ApprovalSettings.categoryId = 'ApprovalSettings';                                                      // 活动选项（表单定义+活动构件）
        ApprovalSettings.categoryName = mxResources.get('approvalSettings');
        ApprovalSettings.tabId = 'advanced';
        ApprovalSettings.tabName = mxResources.get('advancedAttributes');
        ApprovalSettings.properties = [
            { propertyID: UserActivityPropertyKeys.anonymousSet, propertyName: mxResources.get('anonymousSet'), propertyType: 'modal' },
            { propertyID: UserActivityPropertyKeys.approvalPivotConfig, propertyName: mxResources.get('approvalPivotConfig'), propertyType: 'modal' },
            { propertyID: UserActivityPropertyKeys.imageSettings, propertyName: mxResources.get('imageSettings'), propertyType: 'modal' },
            { propertyID: UserActivityPropertyKeys.MultiInstanceLoopCharacteristics, propertyName: mxResources.get('multiInstanceLoopCharacteristics'), propertyType: 'modal' }
        ];
        propertyData[UserActivityPropertyKeys.MultiInstanceLoopCharacteristics] = userAct.LoopCharacteristics;

        let taskTimeliness: ElementPropertyConfig = new ElementPropertyConfig();
        taskTimeliness.categoryId = 'taskTimeliness';                                                      // 活动选项（表单定义+活动构件）
        taskTimeliness.categoryName = mxResources.get('taskTimeliness');
        taskTimeliness.tabId = 'advanced';
        taskTimeliness.tabName = mxResources.get('advancedAttributes');
        taskTimeliness.properties = [
            { propertyID: UserActivityPropertyKeys.timeLimitControl, propertyName: mxResources.get('timeLimitControl'), propertyType: 'modal' },
            { propertyID: UserActivityPropertyKeys.messageNotice, propertyName: mxResources.get('messageNotice'), propertyType: 'modal' },
        ];

        let formDef = new ElementPropertyConfig();
        formDef.categoryId = 'formDef';
        formDef.categoryName = mxResources.get('formDef');
        formDef.tabId = 'basic';
        formDef.tabName = mxResources.get('basicAttributes');
        formDef.properties = [
            { propertyID: UserActivityPropertyKeys.DisplayTerminal, propertyName: mxResources.get('displayTerminal'), propertyType: 'select' },
            { propertyID: UserActivityPropertyKeys.wf_ExecuteForms_PC, propertyName: mxResources.get('pcForm'), propertyType: 'modal' },
            { propertyID: UserActivityPropertyKeys.wf_ExecuteForms_Mobile, propertyName: mxResources.get('webForm'), propertyType: 'modal' },
        ];

        // 扩展属性分group处理，每个group包含父级属性和属于它的子扩展属性
        const groupList = new Array();
        for (const extend of extendList) {
            if (!extend.parentId) {
                const group = { parent: extend, childs: new Array() };
                for (const e of extendList) {
                    if (e.parentId === extend.id) {
                        group.childs.push(e);
                    }
                }
                groupList.push(group)
            }
        }
        // 没有扩展属性值的时候不显示扩展属性一栏
        if (groupList && groupList.length > 0) {
            let ExtendPropertyConfig: ElementPropertyConfig = new ElementPropertyConfig();
            ExtendPropertyConfig.categoryId = 'extendPropertyConfig';
            ExtendPropertyConfig.categoryName = mxResources.get('extendPropertyConfig');
            ExtendPropertyConfig.tabId = 'advanced';
            ExtendPropertyConfig.tabName = mxResources.get('advancedAttributes');
            ExtendPropertyConfig.properties = new Array();
            for (const g of groupList) {
                ExtendPropertyConfig.properties.push(
                    { propertyID: g.parent.id, propertyName: g.parent.propertyTitle, propertyType: 'modal' },
                );
            }
            this.setPropertyData(userAct, propertyData, groupList);

            return {
                propertyConfig: [basicProperty, performerProperty, formDef, approvalProperty, eventListeners, taskTimeliness, ApprovalSettings, ExtendPropertyConfig],
                propertyData: propertyData
            }
        } else {
            this.setPropertyData(userAct, propertyData, groupList);
            return {
                propertyConfig: [basicProperty, performerProperty, formDef, approvalProperty, eventListeners, taskTimeliness, ApprovalSettings],
                propertyData: propertyData
            }
        }
    }

    /**
     * 判断是否存在反向流程动作
     * @param conclusions
     */
    isBackConclusionExist(conclusions: ConclusionItem[]) {
        for (let conclusion of conclusions) {
            if (conclusion.WorkFlowAction === WorkFlowAction.Backward) {
                return true;
            }
        }
        return false;
    }

    /**
     * 组织UserActivity的属性值propertyData
     * @param act
     * @param propertyData
     */
    setPropertyData(act: UserActivity, propertyData: any, groupList: any): void {
        propertyData[UserActivityPropertyKeys.Id] = act.Id;
        propertyData[UserActivityPropertyKeys.ClrTypeID] = act.ClrTypeID;
        propertyData[UserActivityPropertyKeys.Name] = act.Name;
        propertyData[UserActivityPropertyKeys.NameLanguage] = act.NameLanguage || {
            "zh-CHS": act.Name,
        };

        //活动传递bizActivityId
        propertyData[UserActivityPropertyKeys.BizActivityID] = act.BizActivityID;

        // 变量设置+流程变量
        propertyData[UserActivityPropertyKeys.variableSettings] = PropertyHelper.getVariableSettings(act.Model, act.variableSettings);

        propertyData[UserActivityPropertyKeys.ParticipantSchemes] = this.getParticipantInfo(act);
        propertyData[UserActivityPropertyKeys.ParticipantOptions] = this.getParticipantOptions(act);
        // if (userAct.AssignmentStrategy === AssignmentStrategy.ASSIGN) {
        //     propertyData[UserActivityPropertyKeys.AssignPerformer] = this.getPotentialOwnerImpl(userAct);
        // }

        propertyData[UserActivityPropertyKeys.ApprovalItems] = act.Conclusions;
        propertyData[UserActivityPropertyKeys.Tools] = PropertyHelper.getBizComponentList(act.Tools as Array<Component>);
        propertyData[UserActivityPropertyKeys.wf_CustomizeAction] = act.customizeActions || [];

        propertyData[UserActivityPropertyKeys.AssignStrategy] = this.getAssignStrategy(act);

        propertyData[UserActivityPropertyKeys.Retrievable] = act.Retrievable;
        propertyData[UserActivityPropertyKeys.SelectBranch] = act.SelectBranch;
        propertyData[UserActivityPropertyKeys.AddSignFrontAble] = this.getSignFrontInfo(act);
        propertyData[UserActivityPropertyKeys.AddSignBehindAble] = this.getSignBehindInfo(act);
        propertyData[UserActivityPropertyKeys.transferScope] = this.getTransferScopeInfo(act);
        propertyData[UserActivityPropertyKeys.NotifyAble] = this.getNotifyAble(act);
        propertyData[UserActivityPropertyKeys.timeLimitControl] = this.getTimeLimitInfo(act);

        propertyData[UserActivityPropertyKeys.wf_TitleExpression] = act.taskTitle ? (act.taskTitle.valueLanguage ? act.taskTitle.valueLanguage : act.taskTitle.value) : '';
        propertyData[UserActivityPropertyKeys.anonymousSet] = {
            isAnonymity: act.anonymous,
            anonymous: act.anonymousText
        };
        propertyData[UserActivityPropertyKeys.messageNotice] = PropertyHelper.getMessageNotices(act.messageNotices);
        // 影像设置
        propertyData[UserActivityPropertyKeys.imageSettings] = act.imageSettings;
        propertyData[UserActivityPropertyKeys.wf_ExecuteForms_PC] =
            act.ExecuteForms ? act.ExecuteForms.find(e => e.TerminalType === 'PC') : null;
        propertyData[UserActivityPropertyKeys.wf_ExecuteForms_Mobile] =
            act.ExecuteForms ? act.ExecuteForms.find(e => e.TerminalType === 'MOBILE') : null;
        propertyData[UserActivityPropertyKeys.approvalPivotConfig] = act.approvalPivotConfig;
        propertyData[UserActivityPropertyKeys.DisplayTerminal] = act.DisplayTerminal ? act.DisplayTerminal : DisplayTerminal.ALL;
        propertyData[UserActivityPropertyKeys.urgeHandleRule] = this.getUrgeHandleRule(act);
        for (const g of groupList) {
            // 取回模型上的value值给到扩展属性组件里
            if (act.extendProperties && act.extendProperties.length > 0) {
                g.childs.sort((a, b) => {
                    return a.sortOrder - b.sortOrder;
                }).forEach((d: any) => {
                    act.extendProperties.forEach(e => {
                        if (e.key == d.code) {
                            d.value = e.value;
                        }
                    });
                });
            }
            propertyData[g.parent.id] = g.childs;
        }
        propertyData[UserActivityPropertyKeys.checkConditions] = this.getCheckConditions(act);

    }

    getParticipantInfo(userActivity: UserActivity): ParticipantInfo {
        const partiInfo = new ParticipantInfo();
        partiInfo.assignStrategy.assignStrategy = userActivity.AssignmentStrategy;
        const roles = userActivity.GetResourceRoles().filter(role => role instanceof HumanPerformerImpl) as Array<HumanPerformerImpl>;
        partiInfo.humanPerformerList = PropertyHelper.getPerformerList(roles);
        if (userActivity.AssignmentStrategy === AssignmentStrategy.ASSIGN) {
            if (userActivity.AssignPerformerConfig) {
                const assignConfig = new AssignConfig();
                assignConfig.operator = userActivity.AssignPerformerConfig.Operator;
                assignConfig.multiSelect = userActivity.AssignPerformerConfig.MultiSelect;
                assignConfig.necessary = userActivity.AssignPerformerConfig.Necessary;
                partiInfo.assignStrategy.assignConfig = assignConfig;
                partiInfo.isAllScope = userActivity.AssignPerformerConfig.AllowGlobalAssign;
            }
            const roles = userActivity.GetResourceRoles().filter(role => role instanceof PotentialOwnerImpl) as Array<PotentialOwnerImpl>;
            partiInfo.potentialOwnerList = PropertyHelper.getPerformerList(roles);
        }

        return partiInfo;
    }

    getParticipantOptions(userActivity: UserActivity) {
        const options: any = {};
        if (userActivity.ParticipantSetting != null) {
            options.ExclusionPerformers = userActivity.ParticipantSetting.ExclusionPerformers;
            options.NoPerformerStrategy = userActivity.ParticipantSetting.NoPerformerStrategy;
            options.HistoricFirst = userActivity.ParticipantSetting.HistoricFirst;
            options.automaticPerformers = userActivity.ParticipantSetting.automaticPerformers;
        }
        return options;
    }

    getAssignStrategy(userActivity: UserActivity): AssignStrategy {
        const assignStrategy = new AssignStrategy();
        assignStrategy.assignStrategy = userActivity.AssignmentStrategy;
        if (userActivity.AssignPerformerConfig) {
            const assignConfig = new AssignConfig();
            assignConfig.operator = userActivity.AssignPerformerConfig.Operator;
            assignConfig.multiSelect = userActivity.AssignPerformerConfig.MultiSelect;
            assignConfig.necessary = userActivity.AssignPerformerConfig.Necessary;
            assignStrategy.assignConfig = assignConfig;
        }
        return assignStrategy;
    }


    getSignFrontInfo(userActivity: UserActivity): ActionOrganizationScopeDesign {
        const signFrontTest = new ActionOrganizationScopeDesign();
        signFrontTest.action = ActionScope.AddSignFront as any;
        if (userActivity.AddSignFrontAble) {
            signFrontTest.enable = true;
            const roles = userActivity.dynamicParticipants.filter(r => r.actionScope === ActionScope.AddSignFront);
            let res = roles.find(r => (r as any).organizationLevel && !(r as any).order);
            let list : Participant[] = [];
            if(res) {
                const organization = new OrganizationParticipant;
                organization.id = res.id;
                organization.type = res.ClrTypeID;
                organization.name = res.name;
                organization.actionScope = res.actionScope as any;
                organization.organizationLevel = (res as any).organizationLevel;
                organization.organizationId = (res as any).organizationId;
                organization.organizationCode = (res as any).organizationCode;
                organization.organizationName = (res as any).organizationName;
                organization.includeChildren = (res as any).includeChildren;
                organization.parentsUntil = (res as any).parentsUntil;
                organization.tag = (res as any).tag;
                organization.order = 1;
                list.push(organization);
            }else {
                list = PropertyHelper.getPerformerListTest(roles);
            }
            signFrontTest.scope = new OrganizationPotentialOwner();
            if(list && list.length > 0) {
                signFrontTest.scope.participantInfo = new ParticipantInfo();
                signFrontTest.scope.participantInfo.potentialOwnerList = list;
                signFrontTest.scope.participantInfo.isAllScope = true;
            }else {
                signFrontTest.scope.participantInfo = new ParticipantInfo();
                signFrontTest.scope.participantInfo.isAllScope = false;
            }
        } else {
            signFrontTest.enable = false;
        }
        return signFrontTest;
    }
    getSignBehindInfo(userActivity: UserActivity): ActionOrganizationScopeDesign {
        const signBehindTest = new ActionOrganizationScopeDesign();
        signBehindTest.action = ActionScope.AddSignBehind as any;
        if (userActivity.AddSignBehindAble) {
            signBehindTest.enable = true;
            const roles = userActivity.dynamicParticipants.filter(r => r.actionScope === ActionScope.AddSignBehind);
            let res = roles.find(r => (r as any).organizationLevel && !(r as any).order);
            let list : Participant[] = [];
            if(res) {
                const organization = new OrganizationParticipant;
                organization.id = res.id;
                organization.type = res.ClrTypeID;
                organization.name = res.name;
                organization.actionScope = res.actionScope as any;
                organization.organizationLevel = (res as any).organizationLevel;
                organization.organizationId = (res as any).organizationId;
                organization.organizationCode = (res as any).organizationCode;
                organization.organizationName = (res as any).organizationName;
                organization.includeChildren = (res as any).includeChildren;
                organization.parentsUntil = (res as any).parentsUntil;
                organization.tag = (res as any).tag;
                organization.order = 1;
                list.push(organization);
            }else {
                list = PropertyHelper.getPerformerListTest(roles);
            }
            signBehindTest.scope = new OrganizationPotentialOwner();
            if(list && list.length > 0) {
                signBehindTest.scope.participantInfo = new ParticipantInfo();
                signBehindTest.scope.participantInfo.potentialOwnerList = list;
                signBehindTest.scope.participantInfo.isAllScope = true;
            }else {
                signBehindTest.scope.participantInfo = new ParticipantInfo();
                signBehindTest.scope.participantInfo.isAllScope = false;
            }
        } else {
            signBehindTest.enable = false;
        }
        return signBehindTest;
    }
    getTransferScopeInfo(userActivity: UserActivity): ActionOrganizationScopeDesign {
        const transferScopeTest = new ActionOrganizationScopeDesign();
        transferScopeTest.action = ActionScope.Transfer as any;

        if (userActivity.transferAble) {
            transferScopeTest.enable = true;
            const roles = userActivity.dynamicParticipants.filter(r => r.actionScope === ActionScope.Transfer);
            let res = roles.find(r => (r as any).organizationLevel && !(r as any).order);
            let list : Participant[] = [];
            if(res) {
                const organization = new OrganizationParticipant;
                organization.id = res.id;
                organization.type = res.ClrTypeID;
                organization.name = res.name;
                organization.actionScope = res.actionScope as any;
                organization.organizationLevel = (res as any).organizationLevel;
                organization.organizationId = (res as any).organizationId;
                organization.organizationCode = (res as any).organizationCode;
                organization.organizationName = (res as any).organizationName;
                organization.includeChildren = (res as any).includeChildren;
                organization.parentsUntil = (res as any).parentsUntil;
                organization.tag = (res as any).tag;
                organization.order = 1;
                list.push(organization);
            }else {
                list = PropertyHelper.getPerformerListTest(roles);
            }
            transferScopeTest.scope = new OrganizationPotentialOwner();
            if(list && list.length > 0) {
                transferScopeTest.scope.participantInfo = new ParticipantInfo();
                transferScopeTest.scope.participantInfo.potentialOwnerList = list;
                transferScopeTest.scope.participantInfo.isAllScope = true;
            }else {
                transferScopeTest.scope.participantInfo = new ParticipantInfo();
                transferScopeTest.scope.participantInfo.isAllScope = false;
            }
        } else {
            transferScopeTest.enable = userActivity.transferAble;
        }
        return transferScopeTest;
    }
    getNotifyAble(userActivity: UserActivity): ActionOrganizationScopeDesign {
        const notifyScopeTest = new ActionOrganizationScopeDesign();
        notifyScopeTest.action = ActionScope.Notify as any;

        if (userActivity.NotifyAble) {
            notifyScopeTest.enable = true;
            const roles = userActivity.dynamicParticipants.filter(r => r.actionScope === ActionScope.Notify);
            let res = roles.find(r => (r as any).organizationLevel && !(r as any).order);
            let list : Participant[] = [];
            if(res) {
                const organization = new OrganizationParticipant;
                organization.id = res.id;
                organization.type = res.ClrTypeID;
                organization.name = res.name;
                organization.actionScope = res.actionScope as any;
                organization.organizationLevel = (res as any).organizationLevel;
                organization.organizationId = (res as any).organizationId;
                organization.organizationCode = (res as any).organizationCode;
                organization.organizationName = (res as any).organizationName;
                organization.includeChildren = (res as any).includeChildren;
                organization.parentsUntil = (res as any).parentsUntil;
                organization.tag = (res as any).tag;
                organization.order = 1;
                list.push(organization);
            }else {
                list = PropertyHelper.getPerformerListTest(roles);
            }
            notifyScopeTest.scope = new OrganizationPotentialOwner();
            if(list && list.length > 0) {
                notifyScopeTest.scope.participantInfo = new ParticipantInfo();
                notifyScopeTest.scope.participantInfo.potentialOwnerList = list;
                notifyScopeTest.scope.participantInfo.isAllScope = true;
            }else {
                notifyScopeTest.scope.participantInfo = new ParticipantInfo();
                notifyScopeTest.scope.participantInfo.isAllScope = false;
            }
        } else {
            notifyScopeTest.enable = userActivity.NotifyAble;
        }
        return notifyScopeTest;
    }
    getTimeLimitInfo(userActivity: UserActivity): TimeLimitControlInfo {
        if (userActivity.timeLimitControl) {
            const timeLimit = new TimeLimitControlInfo();
            timeLimit.enable = userActivity.timeLimitControl.enable;
            timeLimit.tag = userActivity.timeLimitControl.tag;
            timeLimit.dueTime = userActivity.timeLimitControl.dueTime;
            timeLimit.timeUnit = userActivity.timeLimitControl.timeUnit;
            timeLimit.expireOperations = new Array();
            if (userActivity.timeLimitControl.expireOperations && userActivity.timeLimitControl.expireOperations.length > 0) {
                const operations = userActivity.timeLimitControl.expireOperations;
                for (const o of operations) {
                    if (o.ClrTypeID.indexOf('SendMessageExpireOperation') > 0) {
                        const operation = o as SendMessageExpireOperation;
                        const sendMessage = new SendMessageExpireOperationInfo();
                        sendMessage.timeDuration = operation.timeDuration;
                        sendMessage.durationType = operation.durationType;
                        sendMessage.timeUnit = operation.timeUnit;
                        sendMessage.message = operation.message;
                        sendMessage.sendType = operation.sendType;
                        sendMessage.subject = operation.subject;
                        sendMessage.id = operation.id;
                        sendMessage.receiver = operation.receiver;
                        sendMessage.cycleEnable = operation.cycleEnable;
                        sendMessage.cycleTime = operation.cycleTime;
                        sendMessage.cycleTimeUnit = operation.cycleTimeUnit;
                        sendMessage.operationTypeName = operation.operationTypeName ? operation.operationTypeName : 'SendMessageExpireOperation';
                        if (operation.smsMessageTemplate) {
                            const smsTemplate: any = new Object;
                            smsTemplate.code = operation.smsMessageTemplate.code;
                            smsTemplate.content = operation.smsMessageTemplate.content;
                            smsTemplate.smsMessageVariables = new Array();
                            if (operation.smsMessageTemplate.smsMessageVariables && operation.smsMessageTemplate.smsMessageVariables.length > 0) {
                                for (const v of operation.smsMessageTemplate.smsMessageVariables) {
                                    const variable: any = new Object;
                                    variable.id = WfDesignerUtils.createNM();
                                    variable.code = v.code;
                                    variable.value = v.value;
                                    variable.tag = v.tag;
                                    smsTemplate.smsMessageVariables.push(variable);
                                }
                            }
                            sendMessage.smsMessageTemplate = smsTemplate;
                        }
                        timeLimit.expireOperations.push(sendMessage);
                    } else if (o.ClrTypeID.indexOf('AutoHandleExpireOperation') > 0) {
                        const operation = o as AutoHandleExpireOperation;
                        const autoHandle = new AutoHandleExpireOperationInfo();
                        autoHandle.id = operation.id;
                        autoHandle.durationType = operation.durationType;
                        autoHandle.timeDuration = operation.timeDuration;
                        autoHandle.timeUnit = operation.timeUnit;
                        autoHandle.operationTypeName = operation.operationTypeName ? operation.operationTypeName : 'AutoHandleExpireOperation';
                        autoHandle.autoHandleType = operation.autoHandleType;
                        autoHandle.message = operation.message;
                        timeLimit.expireOperations.push(autoHandle);
                    }

                }
            }
            return timeLimit;
        }
        return null;
    }

    getUrgeHandleRule(userActivity: UserActivity) {
        if (!userActivity.urgeHandleRule) {
            return null;
        }
        const rule = userActivity.urgeHandleRule;
        let urgeHandleRule: any = {
            urgeHandleAble: rule.urgeHandleAble,
            sendType: rule.sendType,
            earlyTime: rule.earlyTime,
            intervalTime: rule.intervalTime,
            urgeMessageSubject: rule.urgeMessageSubject,
            urgeMessageContent: rule.urgeMessageContent,
            addReminder: rule.addReminder,
            subjectEditable: rule.subjectEditable,
            contentEditable: rule.contentEditable,
        }
        if (rule.smsMessageTemplate) {
            const smsTemplate: any = new Object;
            smsTemplate.code = rule.smsMessageTemplate.code;
            smsTemplate.content = rule.smsMessageTemplate.content;
            smsTemplate.smsMessageVariables = new Array();
            if (rule.smsMessageTemplate.smsMessageVariables && rule.smsMessageTemplate.smsMessageVariables.length > 0) {
                for (const v of rule.smsMessageTemplate.smsMessageVariables) {
                    const variable: any = new Object;
                    variable.id = WfDesignerUtils.createNM();
                    variable.code = v.code;
                    variable.value = v.value;
                    variable.tag = v.tag;
                    smsTemplate.smsMessageVariables.push(variable);
                }
            }
            urgeHandleRule.smsMessageTemplate = smsTemplate;
        }
        return urgeHandleRule;
    }

    getCheckConditions(userActivity: UserActivity): Array<any> {
        if (userActivity.checkConditions && userActivity.checkConditions.length > 0) {
            return userActivity.checkConditions.map(c => ({
                value: c.value,
                checkTime: c.checkTime,
                errorTips: c.errorTips ? Array.from(c.errorTips).reduce((obj, [key, value]) => Object.assign(obj, { [key]: value }), {}) : null
            }));
        }
        return null;
    }

    updateProps(obj: any): void {
        this.updatePropsByIsOperation(obj);
    }

    updatePropsByIsOperation(obj: any, isOperation: boolean = false) {
        const editorUi = this.editorUi;
        const userActivity = this.flowElement;
        const propertyId: string = obj.propertyID;
        switch (propertyId) {
            case UserActivityPropertyKeys.ParticipantSchemes: // 参与者属性
                this.updateParticipant(userActivity, obj, isOperation);
                break;
            case UserActivityPropertyKeys.ParticipantOptions: // 参与者选项
                this.updateParticipantOptions(userActivity, obj);
                break;
            // case UserActivityPropertyKeys.AssignPerformer:
            //     this.updatePotentialOwnerImpl(graph.bpmnModel, userActivity, obj);
            //     break;
            // case UserActivityPropertyKeys.AssignStrategy:
            //     this.updateAssignStrategy(graph, userActivity, obj, isOperation);
            //     break;
            // case UserActivityPropertyKeys.OperatorConfig:
            //     this.updateOperatorConfig(userActivity, obj);
            //     break;
            case UserActivityPropertyKeys.CompleteStrategy:
                this.resetExecuteWorkItemMode(userActivity, obj, isOperation);
                break;
            case UserActivityPropertyKeys.DisplayTerminal:
                this.resetDisplayTerminal(userActivity, obj);
                break;
            case UserActivityPropertyKeys.SignRule:
                this.resetSignRules(userActivity, obj, isOperation);
                break;
            case UserActivityPropertyKeys.ApprovalItems:
                this.resetApprovalItems(userActivity, obj, isOperation);
                break;
            case UserActivityPropertyKeys.wf_ExecuteForms_PC:
                this.resetExecuteForm(userActivity, obj, 'PC');
                if (obj.parameters && obj.parameters.length > 0) {
                    PropertyHelper.updateFormalParameters(editorUi.graph.bpmnModel.DefaultProcess, obj.parameters);
                }
                break;
            case UserActivityPropertyKeys.wf_ExecuteForms_Mobile:
                this.resetExecuteForm(userActivity, obj, 'MOBILE');
                if (obj.parameters && obj.parameters.length > 0) {
                    PropertyHelper.updateFormalParameters(editorUi.graph.bpmnModel.DefaultProcess, obj.parameters);
                }
                break;
            case UserActivityPropertyKeys.SelectTargetAble:
                this.resetSelectTargetAble(userActivity, obj, isOperation);
                break;
            case UserActivityPropertyKeys.JumpScope:
                this.resetJumpScope(userActivity, obj);
                break;
            case UserActivityPropertyKeys.BackWardRule:
                this.resetBackWardRule(userActivity, obj);
                break;
            case UserActivityPropertyKeys.MultiInstanceLoopCharacteristics:
                this.resetMultiInstanceLoopCharacteristics(userActivity, obj);
                break;
            case UserActivityPropertyKeys.Tools:
                this.resetTools(userActivity, obj);
                break;
            case UserActivityPropertyKeys.wf_TitleExpression:
                this.modifyTitleExpression(userActivity, obj);
                break;
            case UserActivityPropertyKeys.AddSignFrontAble:
                this.updateSignFrontSet(userActivity, obj);
                break;
            case UserActivityPropertyKeys.AddSignBehindAble:
                this.updateSignBehindsSet(userActivity, obj);
                break;
            case UserActivityPropertyKeys.NotifyAble:
                this.updateNotifySet(userActivity, obj);
                break;
            case UserActivityPropertyKeys.transferScope:
                this.updateTransferScope(userActivity, obj);
                break;
            case UserActivityPropertyKeys.wf_CustomizeAction:
                this.updateCustomizeActions(userActivity, obj);
                break;
            case UserActivityPropertyKeys.timeLimitControl:
                this.updateTimeLimitControl(userActivity, obj);
                break;
            case UserActivityPropertyKeys.anonymousSet:
                this.updateAnonymousSet(userActivity, obj);
                break;
            case UserActivityPropertyKeys.variableSettings:
                this.updateVariableSettings(userActivity, obj);
                break;
            case UserActivityPropertyKeys.messageNotice:
                this.updateMessageNotices(userActivity, obj);
                break;
            case UserActivityPropertyKeys.approvalPivotConfig:
                this.updateApprovalPivotConfig(userActivity, obj);
                break;
            case UserActivityPropertyKeys.urgeHandleRule:
                this.updateUrgeHandleRule(userActivity, obj);
                break;
            case UserActivityPropertyKeys.imageSettings: // 更新变量设置属性
                this.updateImageSettings(userActivity, obj);
                break;
            case UserActivityPropertyKeys.checkConditions:
                this.updateCheckConditions(userActivity, obj, isOperation);
                break;
            case UserActivityPropertyKeys.otherAssignActivities:
                this.updateOtherAssignActivities(userActivity, obj);
                break;
            case UserActivityPropertyKeys.otherAssignActivityNodeInfos:
                this.updateOtherAssignActivities(userActivity, obj);
                break;
            case UserActivityPropertyKeys.otherAssignNodes:
                this.updateOtherAssignNodes(userActivity, obj);
                break;
            default:
                // 判断ResourceKeys是不是groupid,是就走resetExtendProperty
                if (editorUi.procExtProps.findIndex(p => p.id === propertyId) > -1) {
                    this.resetExtendProperty(userActivity, obj);
                } else {
                    super.updateProps(obj);
                }
                break;
        }
    }

    /**
     * 修改参与者
     * @param graph
     * @param userActivity
     * @param obj
     * @param isOperation
     */
    updateParticipant(userActivity: UserActivity, obj: any, isOperation = false) {
        const performerInfo: ParticipantInfo = obj.propertyValue;

        if (performerInfo.assignStrategy.assignStrategy === AssignmentStrategy.CLAIM
            && userActivity.ParticipantSetting
            && userActivity.ParticipantSetting.automaticPerformers
            && userActivity.ParticipantSetting.automaticPerformers.length > 0) {
            // Utils.postMessage(ResourceKeys.wf_showTip, {
            //     type: 'message',
            //     level: 'warning',
            //     message: '当前节点【参与者选项】已设置自动审批，【分配策略】不允许设置为【领用】'
            // });
        } else {
            this.checkOtherAssignNodes(userActivity, performerInfo);
            userActivity.AssignPerformerConfig = null;
            userActivity.AssignmentStrategy = performerInfo.assignStrategy.assignStrategy;
            const resourceRoles = userActivity.GetResourceRoles();
            if (resourceRoles && resourceRoles.length > 0) {
                resourceRoles.forEach(r => {
                    if (r instanceof HumanPerformerImpl) {
                        userActivity.RemoveResourceRole(r.Id);
                    } else if (r instanceof PotentialOwnerImpl) {
                        userActivity.RemoveResourceRole(r.Id);
                    }
                });
            }
            if (performerInfo.humanPerformerList && performerInfo.humanPerformerList.length > 0) {
                for (const humanPerformer of performerInfo.humanPerformerList) {
                    switch (humanPerformer.type) {
                        case UserParticipantExpression.Clr_Type_ID:
                            this.addUserParticipant(userActivity, humanPerformer as UserParticipant, 'humanPerformer', null);
                            break;
                        case VariableParticipantExpression.Clr_Type_ID:
                            this.addVariableParticipant(userActivity, humanPerformer as VariablePerformer, 'humanPerformer', null)
                            break;
                        case PositionParticipantExpression.Clr_Type_ID:
                            this.addPositionParticipant(userActivity, humanPerformer as PositionParticipant, 'humanPerformer', null);
                            break;
                        case ComponentParticipantExpression.Clr_Type_ID:
                            this.addComponentParticipant(userActivity, humanPerformer as ComponentParticipant, 'humanPerformer', null);
                            break;
                        case ReportingLineParticipantExpression.Clr_Type_ID:
                            this.addReportingLineParticipant(userActivity, humanPerformer as ReportingLineParticipant, 'humanPerformer', null);
                            break;
                        case ActivityExecutorParticipantExpression.Clr_Type_ID:
                            this.addActivityExecutorParticipant(userActivity, humanPerformer as ActivityExecutorParticipant, 'humanPerformer', null);
                            break;
                        case MatrixParticipantExpression.Clr_Type_ID:
                            this.addMatrixParticipant(userActivity, humanPerformer as MatrixParticipant, 'humanPerformer', null);
                            break;
                    }
                }
            }
            if (performerInfo.assignStrategy.assignStrategy === AssignmentStrategy.ASSIGN) {

                const assignPerformerConfig = new AssignPerformerConfig(userActivity.Model);
                assignPerformerConfig.Operator = performerInfo.assignStrategy.assignConfig.operator;
                assignPerformerConfig.MultiSelect = performerInfo.assignStrategy.assignConfig.multiSelect;
                assignPerformerConfig.Necessary = performerInfo.assignStrategy.assignConfig.necessary;
                assignPerformerConfig.AllowGlobalAssign = performerInfo.isAllScope;

                userActivity.AssignPerformerConfig = assignPerformerConfig;
                if (!performerInfo.isAllScope && performerInfo.potentialOwnerList && performerInfo.potentialOwnerList.length > 0) {
                    for (const potentialOwner of performerInfo.potentialOwnerList) {
                        switch (potentialOwner.type) {
                            case UserParticipantExpression.Clr_Type_ID:
                                this.addUserParticipant(userActivity, potentialOwner as UserParticipant, 'potentialOwner', null);
                                break;
                            case VariableParticipantExpression.Clr_Type_ID:
                                this.addVariableParticipant(userActivity, potentialOwner as VariablePerformer, 'potentialOwner', null)
                                break;
                            case PositionParticipantExpression.Clr_Type_ID:
                                this.addPositionParticipant(userActivity, potentialOwner as PositionParticipant, 'potentialOwner', null);
                                break;
                            case ComponentParticipantExpression.Clr_Type_ID:
                                this.addComponentParticipant(userActivity, potentialOwner as ComponentParticipant, 'potentialOwner', null);
                                break;
                            case ReportingLineParticipantExpression.Clr_Type_ID:
                                this.addReportingLineParticipant(userActivity, potentialOwner as ReportingLineParticipant, 'potentialOwner', null);
                                break;
                            case ActivityExecutorParticipantExpression.Clr_Type_ID:
                                this.addActivityExecutorParticipant(userActivity, potentialOwner as ActivityExecutorParticipant, 'potentialOwner', null);
                                break;
                            case MatrixParticipantExpression.Clr_Type_ID:
                                this.addMatrixParticipant(userActivity, potentialOwner as MatrixParticipant, 'potentialOwner', null);
                                break;
                            case OrganizationParticipantExpression.Clr_Type_ID:
                                this.addOrganizationParticipant(userActivity, potentialOwner as OrganizationParticipant, 'potentialOwner', null);
                                break;
                        }
                    }
                }
            }
            // 分配策略为领用时，完成策略自动修改为抢占模式
            if (userActivity.AssignmentStrategy === AssignmentStrategy.CLAIM) {
                userActivity.ExecuteWorkItemMode = ExecuteWorkItemMode.Preempt;
                userActivity.CounterSignRules = null;
            }
        }

    }

    checkOtherAssignNodes(userActivity: UserActivity, performerInfo: ParticipantInfo) {
        if (userActivity.AssignmentStrategy !== AssignmentStrategy.ASSIGN) {
            return;
        }
        const bpmnModel = userActivity.Model;
        const flowElements = bpmnModel.DefaultProcess.GetFlowElements();
        if (performerInfo.assignStrategy.assignStrategy !== AssignmentStrategy.ASSIGN) {
            for (const k in flowElements) {
                if (flowElements[k] instanceof UserActivity) {
                    const activity = flowElements[k] as UserActivity;
                    if (activity.otherAssignNodes && activity.otherAssignNodes.otherAssignActivities
                        && activity.otherAssignNodes.otherAssignActivities.length > 0
                        && activity.otherAssignNodes.otherAssignActivities.findIndex(id => id === userActivity.Id) > -1
                    ) {
                        activity.otherAssignNodes.otherAssignActivities = activity.otherAssignNodes.otherAssignActivities.filter(id => id !== userActivity.Id);
                    }
                } else if (flowElements[k] instanceof OperationActivity) {
                    const operationActivity = flowElements[k] as OperationActivity;
                    if (operationActivity.otherAssignNodes && operationActivity.otherAssignNodes.otherAssignActivities
                        && operationActivity.otherAssignNodes.otherAssignActivities.length > 0
                        && operationActivity.otherAssignNodes.otherAssignActivities.findIndex(id => id === userActivity.Id) > -1
                    ) {
                        operationActivity.otherAssignNodes.otherAssignActivities = operationActivity.otherAssignNodes.otherAssignActivities.filter(id => id !== userActivity.Id);
                    }
                } else if (flowElements[k] instanceof StartActivity) {
                    const startActivity = flowElements[k] as StartActivity;
                    if (startActivity.otherAssignNodes && startActivity.otherAssignNodes.otherAssignActivities
                        && startActivity.otherAssignNodes.otherAssignActivities.length > 0
                        && startActivity.otherAssignNodes.otherAssignActivities.findIndex(id => id === userActivity.Id) > -1
                    ) {
                        startActivity.otherAssignNodes.otherAssignActivities = startActivity.otherAssignNodes.otherAssignActivities.filter(id => id !== userActivity.Id);
                    }
                }
            }
        } else {
            if (userActivity.AssignPerformerConfig.Operator === 'currentUser'
                && performerInfo.assignStrategy.assignConfig.operator !== 'currentUser'
            ) {
                for (const k in flowElements) {
                    if (flowElements[k] instanceof UserActivity) {
                        const activity = flowElements[k] as UserActivity;
                        if (activity.otherAssignNodes && activity.otherAssignNodes.otherAssignActivities
                            && activity.otherAssignNodes.otherAssignActivities.length > 0
                            && activity.otherAssignNodes.otherAssignActivities.findIndex(id => id === userActivity.Id) > -1
                        ) {
                            activity.otherAssignNodes.otherAssignActivities = activity.otherAssignNodes.otherAssignActivities.filter(id => id !== userActivity.Id);
                        }
                    } else if (flowElements[k] instanceof OperationActivity) {
                        const operationActivity = flowElements[k] as OperationActivity;
                        if (operationActivity.otherAssignNodes && operationActivity.otherAssignNodes.otherAssignActivities
                            && operationActivity.otherAssignNodes.otherAssignActivities.length > 0
                            && operationActivity.otherAssignNodes.otherAssignActivities.findIndex(id => id === userActivity.Id) > -1
                        ) {
                            operationActivity.otherAssignNodes.otherAssignActivities = operationActivity.otherAssignNodes.otherAssignActivities.filter(id => id !== userActivity.Id);
                        }
                    }
                }
            } else if (userActivity.AssignPerformerConfig.Operator === 'procInstCreator'
                && performerInfo.assignStrategy.assignConfig.operator !== 'procInstCreator'
            ) {
                for (const k in flowElements) {
                    if (flowElements[k] instanceof StartActivity) {
                        const startActivity = flowElements[k] as StartActivity;
                        if (startActivity.otherAssignNodes && startActivity.otherAssignNodes.otherAssignActivities
                            && startActivity.otherAssignNodes.otherAssignActivities.length > 0
                            && startActivity.otherAssignNodes.otherAssignActivities.findIndex(id => id === userActivity.Id) > -1
                        ) {
                            startActivity.otherAssignNodes.otherAssignActivities = startActivity.otherAssignNodes.otherAssignActivities.filter(id => id !== userActivity.Id);
                        }
                    }
                }
            }
        }
    }

    /**
     * 添加用户参与者
     * @param userActivity
     * @param performer
     * @param type
     */
    addUserParticipant(userActivity: UserActivity, performer, type: string , scope: ActionScope) {
        let userParticipant : UserParticipantExpression;
        if(performer instanceof UserParticipantExpression) {
            userParticipant = performer;
        }else{
            performer = performer as UserParticipant
            userParticipant = new UserParticipantExpression(userActivity.Model, performer.performerId, performer.performerName, performer.orgType);
            userParticipant.id = performer.id;
            userParticipant.OrgId = performer.orgId;
            userParticipant.UserCode = performer.performerCode;
            userParticipant.actionScope = ActionScope.Default;
            userParticipant.OrgName = performer.orgName;
            userParticipant.Tag = performer.tag;
            userParticipant.OrgType = performer.orgType;
            userParticipant.order = performer.order;
            if (performer.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = performer.condition;
                userParticipant.condition = condition;
            }
        }
        if (type === 'humanPerformer') {
            let humanPerformerImpl = new HumanPerformerImpl(userActivity.Model);
            humanPerformerImpl.participantExpression = userParticipant;
            if (performer.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = performer.condition;
                humanPerformerImpl.condition = condition;
            }
            humanPerformerImpl.order = performer.order;
            userActivity.AddResourceRole(humanPerformerImpl);
        } else if (type === 'potentialOwner') {
            let otentialOwnerImpl = new PotentialOwnerImpl(userActivity.Model);
            otentialOwnerImpl.participantExpression = userParticipant;
            if (performer.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = performer.condition;
                otentialOwnerImpl.condition = condition;
            }
            otentialOwnerImpl.order = performer.order;
            if(scope) {
                userParticipant.actionScope = scope;
                userActivity.dynamicParticipants.push(userParticipant);
            }else {
                userActivity.AddResourceRole(otentialOwnerImpl);
            }
        }
    }

    /**
     * 添加变量参与者
     * @param userActivity
     * @param performer
     * @param type
     */
    addVariableParticipant(userActivity: UserActivity, performer, type: string, scope: ActionScope) {
        let variablePerformer: VariableParticipantExpression;
        if(performer instanceof VariableParticipantExpression) {
            variablePerformer = performer;
        }else{
            performer = performer as VariablePerformer;
            variablePerformer = new VariableParticipantExpression(userActivity.Model, performer.performerId, performer.performerName, performer.orgType);
            variablePerformer.id = performer.id;
            variablePerformer.actionScope = ActionScope.Default;
            variablePerformer.Name = performer.performerName ? performer.performerName : performer.name;
            variablePerformer.Tag = performer.tag;
            variablePerformer.VarValue = performer.varValue;
            variablePerformer.VarType = performer.varType;
            variablePerformer.order = performer.order;
            variablePerformer.Relation = performer.relation;
            if (performer.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = performer.condition;
                variablePerformer.condition = condition;
            }
        }
        if (type === 'humanPerformer') {
            let humanPerformerImpl = new HumanPerformerImpl(userActivity.Model);
            humanPerformerImpl.participantExpression = variablePerformer;
            if (performer.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = performer.condition;
                humanPerformerImpl.condition = condition;
            }
            humanPerformerImpl.order = performer.order;
            userActivity.AddResourceRole(humanPerformerImpl);
        } else if (type === 'potentialOwner') {
            let otentialOwnerImpl = new PotentialOwnerImpl(userActivity.Model);
            otentialOwnerImpl.participantExpression = variablePerformer;
            if (performer.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = performer.condition;
                otentialOwnerImpl.condition = condition;
            }
            otentialOwnerImpl.order = performer.order;
            if(scope) {
                variablePerformer.actionScope = scope;
                userActivity.dynamicParticipants.push(variablePerformer);
            }else {
                userActivity.AddResourceRole(otentialOwnerImpl);
            }
        }
    }

    /**
     * 添加岗位参与者
     * @param userActivity
     * @param performer
     * @param type
     */
    addPositionParticipant(userActivity: UserActivity, performer, type: string, scope: ActionScope) {
        let posiParticipant : PositionParticipantExpression;
        if(performer instanceof PositionParticipantExpression) {
            posiParticipant = performer;
        }else{
            performer = performer as PositionParticipant;
            posiParticipant = new PositionParticipantExpression(userActivity.Model, performer.performerId, performer.performerName);
            posiParticipant.id = performer.id;
            posiParticipant.PositionCode = performer.performerCode;
            posiParticipant.actionScope = ActionScope.Default;
            posiParticipant.PositionType = performer.positionType;
            posiParticipant.order = performer.order;
            if (performer.positionType === '1') {
                posiParticipant.OrgId = performer.orgId;
                posiParticipant.OrgName = performer.orgName;
                posiParticipant.OrgType = performer.orgType;
            }
            if (performer.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = performer.condition;
                posiParticipant.condition = condition;
            }
        }
        if (type === 'humanPerformer') {
            let humanPerformerImpl = new HumanPerformerImpl(userActivity.Model);
            humanPerformerImpl.participantExpression = posiParticipant;
            if (performer.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = performer.condition;
                humanPerformerImpl.condition = condition;
            }
            humanPerformerImpl.order = performer.order;
            userActivity.AddResourceRole(humanPerformerImpl);
        } else if (type === 'potentialOwner') {
            let otentialOwnerImpl = new PotentialOwnerImpl(userActivity.Model);
            otentialOwnerImpl.participantExpression = posiParticipant;
            if (performer.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = performer.condition;
                otentialOwnerImpl.condition = condition;
            }
            otentialOwnerImpl.order = performer.order;
            if(scope) {
                posiParticipant.actionScope = scope;
                userActivity.dynamicParticipants.push(posiParticipant);
            }else {
                userActivity.AddResourceRole(otentialOwnerImpl);
            }
        }
    }

    /**
     * 添加构件参与者
     * @param userActivity
     * @param component
     * @param type
     */
    addComponentParticipant(userActivity: UserActivity, component, type: string, scope: ActionScope) {
        let componentParticipant:ComponentParticipantExpression;
        if(component instanceof ComponentParticipantExpression) {
            componentParticipant = component;
        }else {
            component = component as ComponentParticipant;
            componentParticipant = new ComponentParticipantExpression(userActivity.Model);
            componentParticipant.id = component.id;
            componentParticipant.componentId = component.metadataId;
            componentParticipant.actionScope = ActionScope.Default;
            componentParticipant.componentName = component.name;
            componentParticipant.methodName = component.methodName;
            componentParticipant.order = component.order;
            componentParticipant.methodCode = component.methodCode;

            if (component.actualParameters && component.actualParameters.length > 0) {
                let actParas = new Array<ActualParameter>();
                for (let para of component.actualParameters) {
                    let actPara = new ActualParameter(userActivity.Model, para.code, para.value, para.valueText);

                    // TODO:更新参与者会默认把构件参数属性改为contant，临时修复，后续代码优化
                    actPara.Tag = para.tag;
                    if (para.fetchValueMode) {
                        switch (para.fetchValueMode) {
                            case 'express':
                                actPara.Tag = 'expression';
                                break;
                            case 'none':
                                actPara.Tag = 'expression';
                                break;
                            default:
                                actPara.Tag = 'constant';
                                break;
                        }
                    }
                    actParas.push(actPara);
                }
                componentParticipant.actualParameters = actParas;
            }
            if (component.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = component.condition;
                componentParticipant.condition = condition;
            }
        }

        if (type === 'humanPerformer') {
            let humanPerformerImpl = new HumanPerformerImpl(userActivity.Model);
            humanPerformerImpl.participantExpression = componentParticipant;
            if (component.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = component.condition;
                humanPerformerImpl.condition = condition;
            }
            humanPerformerImpl.order = component.order;
            userActivity.AddResourceRole(humanPerformerImpl);
        } else if (type === 'potentialOwner') {
            let otentialOwnerImpl = new PotentialOwnerImpl(userActivity.Model);
            otentialOwnerImpl.participantExpression = componentParticipant;
            if (component.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = component.condition;
                otentialOwnerImpl.condition = condition;
            }
            otentialOwnerImpl.order = component.order;
            if(scope) {
                componentParticipant.actionScope = scope;
                userActivity.dynamicParticipants.push(componentParticipant);
            }else {
                userActivity.AddResourceRole(otentialOwnerImpl);
            }
        }
    }

    /**
     *
     * @param userActivity
     * @param participant
     * @param type
     */
    addReportingLineParticipant(userActivity: UserActivity, participant, type: string, scope: ActionScope) {
        let reportingLine : ReportingLineParticipantExpression;
        if(participant instanceof ReportingLineParticipantExpression) {
            reportingLine = participant;
        }else {
            participant = participant as ReportingLineParticipant;
            reportingLine = new ReportingLineParticipantExpression(userActivity.Model);
            reportingLine.id = participant.id;
            reportingLine.actionScope = ActionScope.Default;
            reportingLine.ReportingLineDefId = participant.reportingLineDefId;
            reportingLine.ReportingLineDefName = participant.reportingLineDefName;
            reportingLine.RefOrgId = participant.refOrgId;
            reportingLine.RefUserId = participant.refUserId;
            reportingLine.RefEmployeeId = participant.refEmployeeId;
            reportingLine.order = participant.order;
            reportingLine.Dimension = participant.dimension;
            reportingLine.Tag = participant.tag;
            if (participant.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = participant.condition;
                reportingLine.condition = condition;
            }
        }

        if (type === 'humanPerformer') {
            let humanPerformerImpl = new HumanPerformerImpl(userActivity.Model);
            humanPerformerImpl.participantExpression = reportingLine;
            if (participant.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = participant.condition;
                humanPerformerImpl.condition = condition;
            }
            humanPerformerImpl.order = participant.order;
            userActivity.AddResourceRole(humanPerformerImpl);
        } else if (type === 'potentialOwner') {
            let otentialOwnerImpl = new PotentialOwnerImpl(userActivity.Model);
            otentialOwnerImpl.participantExpression = reportingLine;
            if (participant.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = participant.condition;
                otentialOwnerImpl.condition = condition;
            }
            otentialOwnerImpl.order = participant.order;
            if(scope) {
                reportingLine.actionScope = scope;
                userActivity.dynamicParticipants.push(reportingLine);
            }else {
                userActivity.AddResourceRole(otentialOwnerImpl);
            }
        }
    }

    /**
     *
     * @param userActivity
     * @param participant
     * @param type
     */
    addActivityExecutorParticipant(userActivity: UserActivity, participant, type: string, scope: ActionScope) {
        let activityExecutor : ActivityExecutorParticipantExpression;
        if(participant instanceof ActivityExecutorParticipantExpression) {
            activityExecutor = participant;
        }else {
            participant = participant as ActivityExecutorParticipant;
            activityExecutor = new ActivityExecutorParticipantExpression(userActivity.Model);
            activityExecutor.id = participant.id;
            activityExecutor.activityDefId = participant.activityDefId;
            activityExecutor.actionScope = ActionScope.Default;
            activityExecutor.order = participant.order;
            activityExecutor.activityDefName = participant.activityDefName;
            if (participant.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = participant.condition;
                activityExecutor.condition = condition;
            }
        }

        if (type === 'humanPerformer') {
            let humanPerformerImpl = new HumanPerformerImpl(userActivity.Model);
            humanPerformerImpl.participantExpression = activityExecutor;
            if (participant.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = participant.condition;
                humanPerformerImpl.condition = condition;
            }
            humanPerformerImpl.order = participant.order;
            userActivity.AddResourceRole(humanPerformerImpl);
        } else if (type === 'potentialOwner') {
            let otentialOwnerImpl = new PotentialOwnerImpl(userActivity.Model);
            otentialOwnerImpl.participantExpression = activityExecutor;
            if (participant.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = participant.condition;
                otentialOwnerImpl.condition = condition;
            }
            otentialOwnerImpl.order = participant.order;
            if(scope) {
                activityExecutor.actionScope = scope;
                userActivity.dynamicParticipants.push(activityExecutor);
            }else {
                userActivity.AddResourceRole(otentialOwnerImpl);
            }
        }
    }

    /**
     *
     * @param userActivity
     * @param participant
     * @param type
     */
    addMatrixParticipant(userActivity: UserActivity, participant, type: string, scope: ActionScope) {
        let matrix : MatrixParticipantExpression;
        matrix = new MatrixParticipantExpression(userActivity.Model);
        if(participant instanceof MatrixParticipantExpression) {
            matrix = participant;
        }else {
            participant = participant as MatrixParticipant;
            matrix = new MatrixParticipantExpression(userActivity.Model);
            matrix.order = participant.order;
            matrix.id = participant.id;
            matrix.actionScope = ActionScope.Default;
            matrix.matrixDefId = participant.matrixDefId;
            matrix.matrixDefName = participant.matrixDefName;
            matrix.conditionField1 = participant.conditionField1;
            matrix.conditionFieldText1 = participant.conditionFieldText1;
            matrix.conditionField2 = participant.conditionField2;
            matrix.conditionFieldText2 = participant.conditionFieldText2;
            matrix.conditionField3 = participant.conditionField3;
            matrix.conditionFieldText3 = participant.conditionFieldText3;
            matrix.multivaluedCondition = participant.multivaluedCondition;
            matrix.dataFieldAlias = participant.dataFieldAlias;
            if (participant.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = participant.condition;
                matrix.condition = condition;
            }
        }

        if (type === 'humanPerformer') {
            let humanPerformerImpl = new HumanPerformerImpl(userActivity.Model);
            humanPerformerImpl.participantExpression = matrix;
            if (participant.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = participant.condition;
                humanPerformerImpl.condition = condition;
            }
            humanPerformerImpl.order = participant.order;
            userActivity.AddResourceRole(humanPerformerImpl);
        } else if (type === 'potentialOwner') {
            let otentialOwnerImpl = new PotentialOwnerImpl(userActivity.Model);
            otentialOwnerImpl.participantExpression = matrix;
            if (participant.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = participant.condition;
                otentialOwnerImpl.condition = condition;
            }
            otentialOwnerImpl.order = participant.order;
            if(scope) {
                matrix.actionScope = scope;
                userActivity.dynamicParticipants.push(matrix);
            }else {
                userActivity.AddResourceRole(otentialOwnerImpl);
            }
        }
    }

    /**
     *
     * @param userActivity
     * @param participant
     * @param type
     */
    addOrganizationParticipant(userActivity: UserActivity, participant, type: string, scope: ActionScope) {
        let potential : OrganizationParticipantExpression;
        if(participant instanceof OrganizationParticipantExpression) {
            potential = participant;
        }else {
            participant = participant as OrganizationParticipant;
            potential = new OrganizationParticipantExpression(userActivity.Model);
            potential.id = participant.id;
            potential.order = participant.order;
            potential.actionScope = ActionScope.AssignUser;
            // potential.organizationLevel = participant.organizationLevel;
            if(participant.organizationLevel === 'DEPARTMENT') {
                potential.organizationLevel = OrganizationLevel.DEPARTMENT;
            }else if(participant.organizationLevel === 'UNIT') {
                potential.organizationLevel = OrganizationLevel.UNIT;
            }else if(participant.organizationLevel === 'DEFAULT'){
                potential.organizationLevel = OrganizationLevel.DEFAULT;
            }
            potential.organizationId = participant.organizationId;
            potential.organizationName = participant.organizationName;
            potential.includeChildren = participant.includeChildren;
            potential.tag = participant.tag;

            if (participant.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = participant.condition;
                potential.condition = condition;
            }
        }

        if (type === 'humanPerformer') {
            let humanPerformerImpl = new HumanPerformerImpl(userActivity.Model);
            humanPerformerImpl.participantExpression = potential;
            if (participant.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = participant.condition;
                humanPerformerImpl.condition = condition;
            }
            humanPerformerImpl.order = participant.order;
            userActivity.AddResourceRole(humanPerformerImpl);
        } else if (type === 'potentialOwner') {
            let otentialOwnerImpl = new PotentialOwnerImpl(userActivity.Model);
            otentialOwnerImpl.participantExpression = potential;
            if (participant.condition) {
                const condition = new Condition(userActivity.Model);
                condition.Value = participant.condition;
                otentialOwnerImpl.condition = condition;
            }
            otentialOwnerImpl.order = participant.order;
            if(scope) {
                potential.actionScope = scope;
                userActivity.dynamicParticipants.push(potential);
            }else {
                userActivity.AddResourceRole(otentialOwnerImpl);
            }
        }
    }

    /**
     * 修改参与者选项
     * @param userActivity
     * @param obj
     */
    updateParticipantOptions(userActivity: UserActivity, obj: any) {
        const options = obj.propertyValue;
        if (userActivity.ParticipantSetting != null) {
            userActivity.ParticipantSetting.ExclusionPerformers = options.ExclusionPerformers;
            userActivity.ParticipantSetting.NoPerformerStrategy = options.NoPerformerStrategy;
            userActivity.ParticipantSetting.HistoricFirst = options.HistoricFirst;
            userActivity.ParticipantSetting.automaticPerformers = options.automaticPerformers;
        } else {
            let participantSetting = new ParticipantSetting(userActivity.Model);
            participantSetting.ExclusionPerformers = options.ExclusionPerformers;
            participantSetting.NoPerformerStrategy = options.NoPerformerStrategy;
            participantSetting.HistoricFirst = options.HistoricFirst;
            participantSetting.automaticPerformers = options.automaticPerformers;
            userActivity.ParticipantSetting = participantSetting;
        }
    }

    /**
     * 修改完成策略属性
     * @param graph
     * @param userActivity
     * @param obj
     * @param isOperation
     */
    resetExecuteWorkItemMode(userActivity: UserActivity, obj: any, isOperation = false) {
        if (userActivity) {
            userActivity.ExecuteWorkItemMode = obj.propertyValue;
            //抢占模式下清空会签规则
            if (userActivity.ExecuteWorkItemMode === ExecuteWorkItemMode.Preempt) {
                userActivity.CounterSignRules = null;
            } else {

                // 会签规则不存在时，即由抢占变为会签时，初始化会签规则
                // 并行会签和串行会签之间切换时，不刷新会签规则
                if (!userActivity.CounterSignRules) {
                    userActivity.CounterSignRules = new Array<CounterSignRule>();
                }
                //会签策略时,不允许跳转；且驳回规则不允许动态选择驳回级次(驳回规则目前需要在流程设计器调整)
                userActivity.SelectTargetAble = false;
                userActivity.JumpScope = null;
                // 切换会签策略时，分配策略不能是领用,自动切换为所有
                // 2023-2-9 修复：由于新增了备选办理人，直接指派导致切换时时备选办理人丢失，修改为只有是领用才切到指所有
                if (userActivity.AssignmentStrategy === AssignmentStrategy.CLAIM) {
                    userActivity.AssignmentStrategy = AssignmentStrategy.ALL;
                }
            }
        }
    }

    resetDisplayTerminal(userActivity: UserActivity, obj: any, isOperation = false) {
        if (userActivity) {
            userActivity.DisplayTerminal = obj.propertyValue;
        }
    }

    /**
     * 更新会签规则属性
     * @param graph
     * @param userActivity
     * @param obj
     * @param isOperation
     */
    resetSignRules(userActivity: UserActivity, obj: any, isOperation = false) {
        if (userActivity) {
            let rules = obj.propertyValue as any[];
            userActivity.CounterSignRules = null;
            if (rules && rules.length > 0) {
                userActivity.CounterSignRules = new Array<CounterSignRule>();
                for (let rule of rules) {
                    let counterSignRule = new CounterSignRule(userActivity.Model);
                    let condition = new Condition(userActivity.Model);
                    condition.Value = rule.completionCondition;
                    counterSignRule.ConclusionValue = rule.conclusionValue;
                    counterSignRule.CalculateType = rule.calculateType;
                    counterSignRule.ConditionValue = rule.conditionValue;
                    counterSignRule.WaitAllVotes = rule.waitAllVotes;
                    counterSignRule.CompletionCondition = condition;
                    userActivity.CounterSignRules.push(counterSignRule);
                }
            }
        }
    }

    /**
     * 更新自定义项属性
     * @param graph
     * @param userActivity
     * @param obj
     * @param isOperation
     */
    resetApprovalItems(userActivity: UserActivity, obj: any, isOperation = false) {
        if (userActivity) {
            let conclusions = obj.propertyValue as any[];
            userActivity.Conclusions = new Array<ConclusionItem>();
            for (let conclusion of conclusions) {
                let item = new ConclusionItem(userActivity.Model);
                item.Value = conclusion.value;
                item.Text = conclusion.text;
                item.WorkFlowAction = conclusion.workFlowAction;
                item.IsDefault = conclusion.isDefault;
                item.commentNecessary = conclusion.commentNecessary;
                item.certification = conclusion.certification;
                item.attachmentNecessary = conclusion.attachmentNecessary;
                item.signatureNecessary = conclusion.signatureNecessary;
                item.defaultComment = conclusion.defaultComment;
                userActivity.Conclusions.push(item);
            }
        }
        // 判断审批项是否包含驳回？不包含时，驳回规则清空
        if (!this.isBackConclusionExist(userActivity.Conclusions)) {
            userActivity.BackWardRule = null;
        } else if (!userActivity.BackWardRule) {
            userActivity.BackWardRule = new BackWardRule(userActivity.Model);
        }
    }

    /**
     * 更新审批活动表单定义属性
     * @param userActivity
     * @param obj
     * @param terminal
     */
    resetExecuteForm(userActivity: UserActivity, obj: any, terminal: string) {
        if (userActivity) {
            let form = obj.propertyValue as any;
            if (!userActivity.ExecuteForms) {
                userActivity.ExecuteForms = new Array<ExecuteForm>();
            }
            userActivity.ExecuteForms = userActivity.ExecuteForms.filter(e => e.TerminalType !== terminal);
            if (form) {
                let params = form.ActualParameters as any[];
                let actParas = new Array<ActualParameter>();
                if (params && params.length > 0) {
                    for (let para of params) {
                        let actPara = new ActualParameter(userActivity.Model, para.Name, para.Value);
                        if (para.Tag) {
                            actPara.Tag = para.Tag;
                        } else {
                            if (para.Value) {
                                if (para.Value.length >= 8 && para.Value.slice(0, 8) === `{"expr":`) {
                                    actPara.Tag = 'expression';
                                } else {
                                    actPara.Tag = 'constant';
                                }
                            } else {
                                actPara.Tag = 'variable';
                            }

                        }
                        actParas.push(actPara);
                    }
                }
                const id = BpmnModelHelper.GenerateElementId();
                let item = new ExecuteForm(userActivity.Model, id, form.Name, actParas);
                item.ComponentId = form.ComponentId;
                item.FormType = form.FormType;
                item.formFormatId = form.formFormatId;
                item.formatConfigId = form.formatConfigId;
                item.TerminalType = form.TerminalType;
                userActivity.ExecuteForms.push(item);
            }
        }
    }

    /**
     * 更新是否允许跳转属性
     * @param graph
     * @param userActivity
     * @param obj
     * @param isOperation
     */
    resetSelectTargetAble(userActivity: UserActivity, obj: any, isOperation = false) {
        const SelectTargetAble = obj.propertyValue as boolean;
        userActivity.SelectTargetAble = SelectTargetAble;
        if (userActivity.SelectTargetAble) {
        } else {
            userActivity.JumpScope = null;
        }
    }

    resetJumpScope(userActivity: UserActivity, obj: any) {
        const data = obj.propertyValue;
        if (data) {
            let jumpScope = new JumpScope(userActivity.Model);
            jumpScope.Category = data.Category;
            jumpScope.DefaultType = data.DefaultType;
            jumpScope.DestinationActivities = data.DestinationActivities;
            jumpScope.DefaultActivity = data.DefaultActivity;
            userActivity.JumpScope = jumpScope;
        } else {
            userActivity.JumpScope = null;
        }
    }

    resetBackWardRule(userActivity: UserActivity, obj: any) {
        const data = obj.propertyValue;
        let backWardRule = new BackWardRule(userActivity.Model);
        backWardRule.TargetRef = data.TargetRef;
        backWardRule.SelectTargetAble = data.SelectTargetAble;
        backWardRule.WaitReturn = data.WaitReturn;
        backWardRule.ResubmitEffect = data.ResubmitEffect;
        backWardRule.DynamicBackWardRuleAble = data.DynamicBackWardRuleAble;
        backWardRule.SelectTargetList = data.SelectTargetList;

        userActivity.BackWardRule = backWardRule;
    }

    resetMultiInstanceLoopCharacteristics(userActivity: UserActivity, obj: any) {
        if(obj.propertyValue) {
            const data = obj.propertyValue;
            let loopCharacteristics = new MultiInstanceLoopCharacteristics(userActivity.Model);
            loopCharacteristics.enable = data.enable;
            loopCharacteristics.sequential = data.sequential;
            loopCharacteristics.loopCardinality = new Expression(userActivity.Model);
            if(data.loopCardinality) {
                let variableExpression = new SemanticExpression(userActivity.Model);
                variableExpression.Value = data.loopCardinality;
                loopCharacteristics.loopCardinality.MexExpression = variableExpression;
            }
            loopCharacteristics.completionCondition = data.completionCondition;
            let rules = data.completionConditionRules as any[];
            loopCharacteristics.completionConditionRules = null;
            if(rules && rules.length > 0) {
                loopCharacteristics.completionConditionRules = new Array<CounterSignRule>();
                for(let rule of rules) {
                    let counterSignRule = new CounterSignRule(userActivity.Model);
                    let condition = new Condition(userActivity.Model);
                    condition.Value = rule.CompletionCondition.Value;
                    counterSignRule.ConclusionValue = rule.ConclusionValue;
                    counterSignRule.CalculateType = rule.CalculateType;
                    counterSignRule.ConditionValue = rule.ConditionValue;
                    counterSignRule.WaitAllVotes = rule.WaitAllVotes;
                    counterSignRule.CompletionCondition = condition;
                    loopCharacteristics.completionConditionRules.push(counterSignRule);
                }
            }
            userActivity.LoopCharacteristics = loopCharacteristics;
        }
    }

    /**
     * 更新活动节点标题
     * @param userActivity
     * @param obj
     */
    modifyTitleExpression(userActivity: UserActivity, obj: any) {
        if (userActivity.taskTitle) {
            userActivity.taskTitle.valueLanguage = obj.propertyValue;
            userActivity.taskTitle.value = obj.propertyValue['zh-CHS'];
        } else {
            const title = new TitleExpression(userActivity.Model, obj.propertyValue['zh-CHS'], obj.propertyValue);
            userActivity.taskTitle = title;
        }
    }

    resetTools(userActivity: UserActivity, obj: any) {
        let tools = obj.propertyValue as any[];
        userActivity.Tools = new Array<Tool>();
        if (tools && tools.length > 0) {
            for (let tool of tools) {
                let component = new Component(userActivity.Model);
                component.Id = tool.id;
                component.Name = tool.name;
                component.Time = tool.executionTime;
                // TODO 写死了构件类型
                component.ComponentType = 'WebServiceComponent';
                component.MetadataId = tool.metadataId;
                component.MethodCode = tool.methodCode;
                component.isForCompensation = tool.isForCompensation;
                component.ActualParameters = [];
                if (tool.actualParameters && (tool.actualParameters as any[]).length > 0) {
                    for (let a of (tool.actualParameters as any[])) {
                        let parameter = new ActualParameter(userActivity.Model, a.code, a.value);
                        component.ActualParameters.push(parameter);
                    }
                }
                userActivity.Tools.push(component);
            }
        }
    }


    updateSignFrontSet(userActivity: UserActivity, obj: any) {
        const scope = obj.propertyValue as ActionOrganizationScopeDesign;
        userActivity.dynamicParticipants = userActivity.dynamicParticipants.filter(p => (p as OrganizationParticipantExpression).actionScope !== ActionScope.AddSignFront);
        userActivity.AddSignFrontAble = scope.enable;

        if (scope.scope) {
            if(scope.scope.organizationLevel) {
                const organizationParticipantExpression = new OrganizationParticipantExpression(userActivity.Model);
                organizationParticipantExpression.id = BpmnModelHelper.GenerateElementId();
                organizationParticipantExpression.actionScope = ActionScope.AddSignFront;
                organizationParticipantExpression.organizationLevel = scope.scope.organizationLevel as any;
                organizationParticipantExpression.organizationId = scope.scope.organizationId;
                organizationParticipantExpression.organizationName = scope.scope.organizationName;
                organizationParticipantExpression.includeChildren = scope.scope.includeChildren;
                organizationParticipantExpression.tag = scope.scope.tag;
                userActivity.dynamicParticipants.push(organizationParticipantExpression);
            }else {
                const performerInfo: ParticipantInfo = scope.scope.participantInfo as any;
                if (performerInfo.isAllScope && performerInfo.potentialOwnerList && performerInfo.potentialOwnerList.length > 0) {
                    for (const potentialOwner of performerInfo.potentialOwnerList) {
                        switch (potentialOwner.type ? potentialOwner.type : ((potentialOwner instanceof ParticipantExpression) ? potentialOwner.ClrTypeID : null)) {
                            case UserParticipantExpression.Clr_Type_ID:
                                this.addUserParticipant(userActivity, (potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as UserParticipant), 'potentialOwner', ActionScope.AddSignFront);
                                break;
                            case VariableParticipantExpression.Clr_Type_ID:
                                this.addVariableParticipant(userActivity, (potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as VariablePerformer), 'potentialOwner', ActionScope.AddSignFront)
                                break;
                            case PositionParticipantExpression.Clr_Type_ID:
                                this.addPositionParticipant(userActivity, (potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as PositionParticipant), 'potentialOwner', ActionScope.AddSignFront);
                                break;
                            case ComponentParticipantExpression.Clr_Type_ID:
                                this.addComponentParticipant(userActivity, (potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as ComponentParticipant), 'potentialOwner', ActionScope.AddSignFront);
                                break;
                            case ReportingLineParticipantExpression.Clr_Type_ID:
                                this.addReportingLineParticipant(userActivity, (potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as ReportingLineParticipant), 'potentialOwner', ActionScope.AddSignFront);
                                break;
                            case ActivityExecutorParticipantExpression.Clr_Type_ID:
                                this.addActivityExecutorParticipant(userActivity, (potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as ActivityExecutorParticipant), 'potentialOwner', ActionScope.AddSignFront);
                                break;
                            case MatrixParticipantExpression.Clr_Type_ID:
                                this.addMatrixParticipant(userActivity, (potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as MatrixParticipant), 'potentialOwner', ActionScope.AddSignFront);
                                break;
                            case OrganizationParticipantExpression.Clr_Type_ID:
                                this.addOrganizationParticipant(userActivity, (potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as OrganizationParticipant), 'potentialOwner' , ActionScope.AddSignFront);
                                break;
                        }
                    }
                }
            }
        }
    }

    updateSignBehindsSet(userActivity: UserActivity, obj: any) {
        const scope = obj.propertyValue as ActionOrganizationScopeDesign;
        userActivity.dynamicParticipants = userActivity.dynamicParticipants.filter(p => (p as OrganizationParticipantExpression).actionScope !== ActionScope.AddSignBehind);
        userActivity.AddSignBehindAble = scope.enable;

        if (scope.scope) {
            if(scope.scope.organizationLevel) {
                const organizationParticipantExpression = new OrganizationParticipantExpression(userActivity.Model);
                organizationParticipantExpression.id = BpmnModelHelper.GenerateElementId();
                organizationParticipantExpression.actionScope = ActionScope.AddSignBehind;
                organizationParticipantExpression.organizationLevel = scope.scope.organizationLevel as any;
                organizationParticipantExpression.organizationId = scope.scope.organizationId;
                organizationParticipantExpression.organizationName = scope.scope.organizationName;
                organizationParticipantExpression.includeChildren = scope.scope.includeChildren;
                organizationParticipantExpression.tag = scope.scope.tag;
                userActivity.dynamicParticipants.push(organizationParticipantExpression);
            }else {
                const performerInfo: ParticipantInfo = scope.scope.participantInfo as any;
                if (performerInfo.isAllScope && performerInfo.potentialOwnerList && performerInfo.potentialOwnerList.length > 0) {
                    for (const potentialOwner of performerInfo.potentialOwnerList) {
                        switch (potentialOwner.type ? potentialOwner.type : ((potentialOwner instanceof ParticipantExpression) ? potentialOwner.ClrTypeID : null)) {
                            case UserParticipantExpression.Clr_Type_ID:
                                this.addUserParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as UserParticipant, 'potentialOwner', ActionScope.AddSignBehind);
                                break;
                            case VariableParticipantExpression.Clr_Type_ID:
                                this.addVariableParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as VariablePerformer, 'potentialOwner', ActionScope.AddSignBehind)
                                break;
                            case PositionParticipantExpression.Clr_Type_ID:
                                this.addPositionParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as PositionParticipant, 'potentialOwner', ActionScope.AddSignBehind);
                                break;
                            case ComponentParticipantExpression.Clr_Type_ID:
                                this.addComponentParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as ComponentParticipant, 'potentialOwner', ActionScope.AddSignBehind);
                                break;
                            case ReportingLineParticipantExpression.Clr_Type_ID:
                                this.addReportingLineParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as ReportingLineParticipant, 'potentialOwner', ActionScope.AddSignBehind);
                                break;
                            case ActivityExecutorParticipantExpression.Clr_Type_ID:
                                this.addActivityExecutorParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as ActivityExecutorParticipant, 'potentialOwner', ActionScope.AddSignBehind);
                                break;
                            case MatrixParticipantExpression.Clr_Type_ID:
                                this.addMatrixParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as MatrixParticipant, 'potentialOwner', ActionScope.AddSignBehind);
                                break;
                            case OrganizationParticipantExpression.Clr_Type_ID:
                                this.addOrganizationParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as OrganizationParticipant, 'potentialOwner' , ActionScope.AddSignBehind);
                                break;
                        }
                    }
                }
            }
        }
    }

    updateNotifySet(userActivity: UserActivity, obj: any) {
        const scope = obj.propertyValue as ActionOrganizationScopeDesign;

        userActivity.dynamicParticipants = userActivity.dynamicParticipants.filter(p => (p as OrganizationParticipantExpression).actionScope !== ActionScope.Notify);
        userActivity.NotifyAble = scope.enable;

        if (scope.scope) {
            if(scope.scope.organizationLevel) {
                const organizationParticipantExpression = new OrganizationParticipantExpression(userActivity.Model);
                organizationParticipantExpression.id = BpmnModelHelper.GenerateElementId();
                organizationParticipantExpression.actionScope = ActionScope.Notify;
                organizationParticipantExpression.organizationLevel = scope.scope.organizationLevel as any;
                organizationParticipantExpression.organizationId = scope.scope.organizationId;
                organizationParticipantExpression.organizationName = scope.scope.organizationName;
                organizationParticipantExpression.includeChildren = scope.scope.includeChildren;
                organizationParticipantExpression.tag = scope.scope.tag;
                userActivity.dynamicParticipants.push(organizationParticipantExpression);
            }else {
                const performerInfo: ParticipantInfo = scope.scope.participantInfo as any;
                if (performerInfo.isAllScope && performerInfo.potentialOwnerList && performerInfo.potentialOwnerList.length > 0) {
                    for (const potentialOwner of performerInfo.potentialOwnerList) {
                        switch (potentialOwner.type ? potentialOwner.type : ((potentialOwner instanceof ParticipantExpression) ? potentialOwner.ClrTypeID : null)) {
                            case UserParticipantExpression.Clr_Type_ID:
                                this.addUserParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as UserParticipant, 'potentialOwner', ActionScope.Notify);
                                break;
                            case VariableParticipantExpression.Clr_Type_ID:
                                this.addVariableParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as VariablePerformer, 'potentialOwner', ActionScope.Notify)
                                break;
                            case PositionParticipantExpression.Clr_Type_ID:
                                this.addPositionParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as PositionParticipant, 'potentialOwner', ActionScope.Notify);
                                break;
                            case ComponentParticipantExpression.Clr_Type_ID:
                                this.addComponentParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as ComponentParticipant, 'potentialOwner', ActionScope.Notify);
                                break;
                            case ReportingLineParticipantExpression.Clr_Type_ID:
                                this.addReportingLineParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as ReportingLineParticipant, 'potentialOwner', ActionScope.Notify);
                                break;
                            case ActivityExecutorParticipantExpression.Clr_Type_ID:
                                this.addActivityExecutorParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as ActivityExecutorParticipant, 'potentialOwner', ActionScope.Notify);
                                break;
                            case MatrixParticipantExpression.Clr_Type_ID:
                                this.addMatrixParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as MatrixParticipant, 'potentialOwner', ActionScope.Notify);
                                break;
                            case OrganizationParticipantExpression.Clr_Type_ID:
                                this.addOrganizationParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as OrganizationParticipant, 'potentialOwner' , ActionScope.Notify);
                                break;
                        }
                    }
                }
            } 
        }
    }
    updateTransferScope(userActivity: UserActivity, obj: any) {
        const scope = obj.propertyValue as ActionOrganizationScopeDesign;

        userActivity.dynamicParticipants = userActivity.dynamicParticipants.filter(p => (p as OrganizationParticipantExpression).actionScope !== ActionScope.Transfer);
        userActivity.transferAble = scope.enable;

        if (scope.scope) {
            if(scope.scope.organizationLevel) {
                const organizationParticipantExpression = new OrganizationParticipantExpression(userActivity.Model);
                organizationParticipantExpression.id = BpmnModelHelper.GenerateElementId();
                organizationParticipantExpression.actionScope = ActionScope.Transfer;
                organizationParticipantExpression.organizationLevel = scope.scope.organizationLevel as any;
                organizationParticipantExpression.organizationId = scope.scope.organizationId;
                organizationParticipantExpression.organizationName = scope.scope.organizationName;
                organizationParticipantExpression.includeChildren = scope.scope.includeChildren;
                organizationParticipantExpression.tag = scope.scope.tag;
                userActivity.dynamicParticipants.push(organizationParticipantExpression);
            }else {
                const performerInfo: ParticipantInfo = scope.scope.participantInfo as any;
                if (performerInfo.isAllScope && performerInfo.potentialOwnerList && performerInfo.potentialOwnerList.length > 0) {
                    for (const potentialOwner of performerInfo.potentialOwnerList) {
                        switch (potentialOwner.type ? potentialOwner.type : ((potentialOwner instanceof ParticipantExpression) ? potentialOwner.ClrTypeID : null)) {
                            case UserParticipantExpression.Clr_Type_ID:
                                this.addUserParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as UserParticipant, 'potentialOwner', ActionScope.Transfer);
                                break;
                            case VariableParticipantExpression.Clr_Type_ID:
                                this.addVariableParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as VariablePerformer, 'potentialOwner', ActionScope.Transfer)
                                break;
                            case PositionParticipantExpression.Clr_Type_ID:
                                this.addPositionParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as PositionParticipant, 'potentialOwner', ActionScope.Transfer);
                                break;
                            case ComponentParticipantExpression.Clr_Type_ID:
                                this.addComponentParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as ComponentParticipant, 'potentialOwner', ActionScope.Transfer);
                                break;
                            case ReportingLineParticipantExpression.Clr_Type_ID:
                                this.addReportingLineParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as ReportingLineParticipant, 'potentialOwner', ActionScope.Transfer);
                                break;
                            case ActivityExecutorParticipantExpression.Clr_Type_ID:
                                this.addActivityExecutorParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as ActivityExecutorParticipant, 'potentialOwner', ActionScope.Transfer);
                                break;
                            case MatrixParticipantExpression.Clr_Type_ID:
                                this.addMatrixParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as MatrixParticipant, 'potentialOwner', ActionScope.Transfer);
                                break;
                            case OrganizationParticipantExpression.Clr_Type_ID:
                                this.addOrganizationParticipant(userActivity, potentialOwner instanceof ParticipantExpression ? potentialOwner : potentialOwner as OrganizationParticipant, 'potentialOwner' , ActionScope.Transfer);
                                break;
                        }
                    }
                }
            }
        }
    }

    updateTimeLimitControl(userActivity: UserActivity, obj: any) {
        const timeLimitInfo = obj.propertyValue as TimeLimitControlInfo;
        userActivity.timeLimitControl = null;
        if (timeLimitInfo) {
            const control = new TimeLimitControl(userActivity.Model);
            control.enable = timeLimitInfo.enable;
            control.tag = timeLimitInfo.tag;
            control.dueTime = timeLimitInfo.dueTime;
            control.timeUnit = timeLimitInfo.timeUnit;
            control.expireOperations = new Array<SendMessageExpireOperation>();
            if (timeLimitInfo.expireOperations && timeLimitInfo.expireOperations.length > 0) {
                for (const o of timeLimitInfo.expireOperations) {
                    if (o.operationTypeName === 'SendMessageExpireOperation' || !o.operationTypeName) {
                        const entity = o as SendMessageExpireOperation;
                        const sendMessage = new SendMessageExpireOperation(userActivity.Model);
                        sendMessage.id = BpmnModelHelper.GenerateElementId();
                        sendMessage.durationType = entity.durationType as DurationType;
                        sendMessage.timeDuration = entity.timeDuration;
                        sendMessage.timeUnit = entity.timeUnit;
                        sendMessage.message = entity.message;
                        sendMessage.subject = entity.subject;
                        sendMessage.sendType = entity.sendType;
                        sendMessage.receiver = entity.receiver;
                        sendMessage.cycleEnable = entity.cycleEnable;
                        sendMessage.cycleTime = entity.cycleTime;
                        sendMessage.cycleTimeUnit = entity.cycleTimeUnit;
                        sendMessage.operationTypeName = entity.operationTypeName ? entity.operationTypeName : 'SendMessageExpireOperation';
                        if (entity.smsMessageTemplate) {
                            const smsMessageTemplate = new SmsMessageTemplate(userActivity.Model);
                            smsMessageTemplate.code = entity.smsMessageTemplate.code;
                            smsMessageTemplate.content = entity.smsMessageTemplate.content;
                            smsMessageTemplate.smsMessageVariables = new Array();
                            if (entity.smsMessageTemplate.smsMessageVariables && entity.smsMessageTemplate.smsMessageVariables.length > 0) {
                                for (const v of entity.smsMessageTemplate.smsMessageVariables) {
                                    const variable = new SmsMessageVariable(userActivity.Model);
                                    variable.code = v.code;
                                    variable.value = v.value;
                                    variable.tag = v.tag;
                                    smsMessageTemplate.smsMessageVariables.push(variable);
                                }
                            }
                            sendMessage.smsMessageTemplate = smsMessageTemplate;
                        }
                        control.expireOperations.push(sendMessage);
                    } else if (o.operationTypeName === 'AutoHandleExpireOperation') {
                        const operation = o as AutoHandleExpireOperation;
                        const autoHandle = new AutoHandleExpireOperation(userActivity.Model);
                        autoHandle.id = o.id;
                        autoHandle.durationType = operation.durationType;
                        autoHandle.timeDuration = operation.timeDuration;
                        autoHandle.timeUnit = operation.timeUnit;
                        autoHandle.operationTypeName = operation.operationTypeName ? operation.operationTypeName : 'AutoHandleExpireOperation';
                        autoHandle.autoHandleType = operation.autoHandleType;
                        autoHandle.message = operation.message;
                        control.expireOperations.push(autoHandle);
                    }
                }
            }
            userActivity.timeLimitControl = control;
        }
    }

    updateAnonymousSet(userActivity: UserActivity, obj: any) {
        const anonymousSet = obj.propertyValue;
        if (anonymousSet) {
            userActivity.anonymous = anonymousSet.isAnonymity;
            userActivity.anonymousText = anonymousSet.anonymous;
        }
    }

    updateCustomizeActions(userActivity: UserActivity, obj: any) {
        let actions = obj.propertyValue as any[];
        userActivity.customizeActions = new Array<CustomizeAction>();
        if (actions && actions.length > 0) {
            for (let a of actions) {
                let action = new CustomizeAction(userActivity.Model);
                action.id = BpmnModelHelper.GenerateElementId();
                action.code = a.code;
                action.name = a.name;
                action.terminalType = a.terminalType;
                action.actualParameters = [];
                if (a.actualParameters && a.actualParameters.length > 0) {
                    for (let p of a.actualParameters) {
                        let parameter = new ActualParameter(userActivity.Model, p.Name, p.Value, p.ValueText, p.Tag || 'expression');
                        action.actualParameters.push(parameter);
                    }
                }

                userActivity.customizeActions.push(action);
            }
        }

    }

    updateVariableSettings(userActivity: UserActivity, obj: any) {
        const bpmnModel = userActivity.Model;
        const extendElements = bpmnModel.DefaultProcess.GetExtensionElements();
        if (userActivity.variableSettings && userActivity.variableSettings.length > 0) {
            for (const v of userActivity.variableSettings) {
                if (v.tag === 'component') {
                    const i = extendElements.findIndex(e => (e instanceof Component && e.Id === v.value));
                    extendElements.splice(i, 1);
                }
            }
        }
        userActivity.variableSettings = new Array();

        const variables = obj.propertyValue as any[];
        if (variables && variables.length > 0) {
            for (const v of variables) {
                const variableSetting = new VariableSetting(bpmnModel);
                variableSetting.variableCode = v.variableCode;
                variableSetting.variableName = v.variableName;
                variableSetting.tag = v.tag;
                variableSetting.executionTime = v.executionTime;
                variableSetting.value = v.value;
                variableSetting.valueText = v.valueText;

                userActivity.variableSettings.push(variableSetting);
                if (variableSetting.tag === 'component') {
                    const c = v.component;
                    if (c) {
                        let cpt = new Component(bpmnModel);
                        cpt.MetadataId = c.MetadataId;
                        cpt.MethodCode = c.MethodCode;
                        cpt.Id = c.Id;
                        cpt.Name = c.Name;
                        cpt.ActualParameters = new Array();
                        if (c.ActualParameters && c.ActualParameters.length > 0) {
                            for (let a of c.ActualParameters) {
                                let parameter = new ActualParameter(bpmnModel, a.Name, a.Value);
                                parameter.Tag = a.Tag;
                                cpt.ActualParameters.push(parameter);
                            }
                        }

                        extendElements.push(cpt);
                    }
                }
            }
        }
    }

    updateImageSettings(userActivity: UserActivity, obj: any) {
        let Settings = obj.propertyValue as any;
        if (userActivity.imageSettings) {
            userActivity.imageSettings = new ImageSettings(userActivity.Model);
        }
        if (Settings && Settings.imageOperation) {
            const imageSettings = new ImageSettings(userActivity.Model);
            imageSettings.imageOperation = Settings.imageOperation;
            userActivity.imageSettings = imageSettings;
        }
    }

    updateCheckConditions(userActivity: UserActivity, obj: any, isOperation = false) {
        const checkConditions = obj.propertyValue as Array<any>;
        userActivity.checkConditions = new Array();
        for (const c of checkConditions) {
            if (c.value) {
                const condition = new CheckCondition(userActivity.Model);
                condition.value = c.value;
                condition.checkTime = c.checkTime;
                condition.errorTips = new Map<string, string>();
                if (c.errorTips) {
                    for (let key in c.errorTips) {
                        condition.errorTips.set(key, c.errorTips[key]);
                    }
                }
                userActivity.checkConditions.push(condition);
            }
        }
    }

    updateOtherAssignNodes(userActivity: UserActivity, obj: any) {
        const data: boolean = obj.propertyValue;
        if (data) {
            // const otherAssignNodes = new OtherAssignNodes(userActivity.Model);
            // otherAssignNodes.otherAssignActivities = new Array();
            // userActivity.otherAssignNodes = otherAssignNodes;
            userActivity.otherAssignNodes = new OtherAssignNodes(userActivity.Model);
        } else {
            userActivity.otherAssignNodes = null;
        }
    }

    updateOtherAssignActivities(userActivity: UserActivity, obj: any) {
        const data:any[] = obj.propertyValue;
        if (data && data.length > 0) {
            if (typeof data[0] === "string") {
                userActivity.otherAssignNodes.otherAssignActivityNodeInfos = new Array<OtherAssignActivityNodeInfo>();
                data.forEach(d => {
                    let other = new OtherAssignActivityNodeInfo(userActivity.Model);
                    other.activityDefinitionId = d;
                    other.required = false;
                    other.condition = new Condition(userActivity.Model);
                    userActivity.otherAssignNodes.otherAssignActivityNodeInfos.push(other);
                });
            } else {
                userActivity.otherAssignNodes.otherAssignActivityNodeInfos = new Array<OtherAssignActivityNodeInfo>();
                data.forEach(d => {
                    let other = new OtherAssignActivityNodeInfo(userActivity.Model);
                    other.activityDefinitionId = d.activityDefinitionId;
                    other.required = d.required;
                    other.condition = new Condition(userActivity.Model);
                    other.condition.Value = d.condition.Value;                    
                    userActivity.otherAssignNodes.otherAssignActivityNodeInfos.push(other);
                });
            }
            // userActivity.otherAssignNodes.otherAssignActivities = [...data];
        } else {
            userActivity.otherAssignNodes.otherAssignActivityNodeInfos = new Array();
        }
    }

    updateMessageNotices(userActivity: UserActivity, obj: any) {
        let notices = obj.propertyValue as any[];
        userActivity.messageNotices = new Array();
        if (notices && notices.length > 0) {
            for (let n of notices) {
                const messageNotice = new MessageNotice(userActivity.Model);
                messageNotice.sendType = n.sendType;
                messageNotice.sendTime = n.sendTime;
                messageNotice.subject = n.subject;
                messageNotice.content = n.content;
                n.receivers = n.receivers.filter((r: any) => r.type);
                if (n.receivers && n.receivers.length > 0) {
                    const receivers = n.receivers.filter((r: any) => r.type === 'userParticipant'
                        || (r.type === 'processParticipant' && r.processParticipant !== 'activityExecutorParticipant'));
                    const participants = n.receivers.filter((r: any) => r.type === 'variableParticipant' || r.type === 'positionParticipant'
                        || (r.type === 'processParticipant' && r.processParticipant === 'activityExecutorParticipant'));
                    if (receivers && receivers.length > 0) {
                        let receiver = '';
                        let receiverName = '';
                        for (const r of receivers) {
                            if (r.type === 'processParticipant') {
                                receiver += (r.processParticipant + ',');
                                if (r.processParticipant === 'procInstCreator') {
                                    receiverName += '流程发起人,'
                                } else if (r.processParticipant === 'workItemParticipant') {
                                    receiverName += '任务接收人,'
                                }
                            } else if (r.type === 'userParticipant') {
                                receiver += (r.userIds + ',');
                                receiverName += (r.userNames + ',');
                            }
                        }
                        if (receiver) {
                            receiver = receiver.substring(0, receiver.length - 1);
                        }
                        if (receiverName) {
                            receiverName = receiverName.substring(0, receiverName.length - 1);
                        }
                        messageNotice.receiver = receiver;
                        messageNotice.receiverText = receiverName;
                    }
                    if (participants && participants.length > 0) {
                        const receiverExpressions = new Array<ParticipantExpression>();
                        for (const p of participants) {
                            if (p.type === 'processParticipant') {
                                let activityExecutor = new ActivityExecutorParticipantExpression(userActivity.Model);
                                activityExecutor.id = BpmnModelHelper.GenerateElementId();
                                activityExecutor.activityDefId = p.activityDefId;
                                activityExecutor.activityDefName = p.activityDefName;
                                receiverExpressions.push(activityExecutor);
                            }
                            if (p.type === 'variableParticipant') {
                                let variableParticipant = new UserParticipantExpression(userActivity.Model, p.variableParticipant, p.variableName, p.orgType);
                                variableParticipant.id = BpmnModelHelper.GenerateElementId();
                                variableParticipant.Tag = 'expression';
                                variableParticipant.OrgType = p.orgType;
                                receiverExpressions.push(variableParticipant);
                            }
                            if (p.type === 'positionParticipant') {
                                let posiParticipant = new PositionParticipantExpression(userActivity.Model, p.positionId, p.positionName);
                                posiParticipant.id = BpmnModelHelper.GenerateElementId();
                                posiParticipant.PositionType = p.positionType;
                                if (p.positionType === '1') {
                                    posiParticipant.OrgId = p.orgId;
                                    posiParticipant.OrgType = p.orgType;
                                }
                                receiverExpressions.push(posiParticipant);
                            }
                        }
                        messageNotice.receiverExpressions = receiverExpressions;
                    }
                }

                if (n.smsMessageTemplate) {
                    const smsMessageTemplate = new SmsMessageTemplate(userActivity.Model);
                    smsMessageTemplate.code = n.smsMessageTemplate.code;
                    smsMessageTemplate.content = n.smsMessageTemplate.content;
                    smsMessageTemplate.smsMessageVariables = new Array();
                    if (n.smsMessageTemplate.smsMessageVariables && n.smsMessageTemplate.smsMessageVariables.length > 0) {
                        for (const v of n.smsMessageTemplate.smsMessageVariables) {
                            const variable = new SmsMessageVariable(userActivity.Model);
                            variable.code = v.code;
                            variable.value = v.value;
                            variable.tag = v.tag;
                            smsMessageTemplate.smsMessageVariables.push(variable);
                        }
                    }
                    messageNotice.smsMessageTemplate = smsMessageTemplate;
                }

                userActivity.messageNotices.push(messageNotice);
            }
        }

    }

    updateApprovalPivotConfig(userActivity: UserActivity, obj: any) {
        let config = obj.propertyValue;
        const approvalPivotConfig = new ApprovalPivotConfig(userActivity.Model);
        approvalPivotConfig.enable = config.enable;
        approvalPivotConfig.expand = config.expand;
        approvalPivotConfig.title = config.title;
        approvalPivotConfig.approvalPivots = new Array();
        if (config.approvalPivots && config.approvalPivots.length > 0) {
            for (const a of config.approvalPivots) {
                const approvalPivot = new ApprovalPivot(userActivity.Model);
                approvalPivot.type = a.type;
                approvalPivot.title = a.title;
                approvalPivot.description = a.description;
                if (a.condition) {
                    const condition = new Condition(userActivity.Model);
                    condition.Value = a.condition;
                    approvalPivot.condition = condition;
                }
                approvalPivotConfig.approvalPivots.push(approvalPivot);
            }
        }
        userActivity.approvalPivotConfig = approvalPivotConfig;
    }

    updateUrgeHandleRule(userActivity: UserActivity, obj: any) {
        const rule = obj.propertyValue;
        const urgeHandleRule = new UrgeHandleRule(userActivity.Model);
        urgeHandleRule.urgeHandleAble = rule.urgeHandleAble;
        urgeHandleRule.sendType = rule.sendType;
        urgeHandleRule.earlyTime = rule.earlyTime;
        urgeHandleRule.intervalTime = rule.intervalTime;
        urgeHandleRule.urgeMessageSubject = rule.urgeMessageSubject;
        urgeHandleRule.urgeMessageContent = rule.urgeMessageContent;
        urgeHandleRule.addReminder = rule.addReminder;
        urgeHandleRule.subjectEditable = rule.subjectEditable;
        urgeHandleRule.contentEditable = rule.contentEditable;

        if (rule.smsMessageTemplate) {
            const smsMessageTemplate = new SmsMessageTemplate(userActivity.Model);
            smsMessageTemplate.code = rule.smsMessageTemplate.code;
            smsMessageTemplate.content = rule.smsMessageTemplate.content;
            smsMessageTemplate.smsMessageVariables = new Array();
            if (rule.smsMessageTemplate.smsMessageVariables && rule.smsMessageTemplate.smsMessageVariables.length > 0) {
                for (const v of rule.smsMessageTemplate.smsMessageVariables) {
                    const variable = new SmsMessageVariable(userActivity.Model);
                    variable.code = v.code;
                    variable.value = v.value;
                    variable.tag = v.tag;
                    smsMessageTemplate.smsMessageVariables.push(variable);
                }
            }
            urgeHandleRule.smsMessageTemplate = smsMessageTemplate;
        }

        userActivity.urgeHandleRule = urgeHandleRule;
    }

    /**
     * 删除节点或参与者时，对应删除HumanResourceRoles
     * @param bpmnModel
     * @param ids
     */
    removeHumanResourceRoles(ids: string[]) {
        const bpmnModel = this.flowElement.Model;
        if (ids && ids.length > 0) {
            const userActivitys = bpmnModel.DefaultProcess.GetFlowElements();
            let perfIds = '';
            for (let key in userActivitys) {
                if (userActivitys[key] instanceof UserActivity) {
                    const userAct = userActivitys[key] as UserActivity;
                    if (userAct.ParticipantSchemes && userAct.ParticipantSchemes.length > 0 && userAct.ParticipantSchemes[0].Performers) {
                        perfIds += (userAct.ParticipantSchemes[0].Performers + ',');
                    }
                }
            }
            const removeIds = ids.filter(id => perfIds.indexOf(id) < 0);
            removeIds.forEach(reId => {
                bpmnModel.DefaultProcess.RemoveResourceRole(reId);
            });
        }
    }

    /**
     * 更新审批活动扩展属性
     * @param userActivity
     * @param obj
     */
    resetExtendProperty(userActivity: UserActivity, obj: any) {
        if (userActivity) {
            let attributes = obj.propertyValue as any;
            if (!userActivity.extendProperties) {
                userActivity.extendProperties = new Array<ExtendProperty>();
            }
            for (const o of obj.propertyValue) {
                const index = userActivity.extendProperties.findIndex(e => e.key === o.code);
                if (index > -1) {
                    userActivity.extendProperties.splice(index, 1);
                }
            }
            if (attributes) {
                attributes.forEach((a: any) => {
                    let item = new ExtendProperty(userActivity.Model);
                    item.key = a.code;
                    item.value = a.value;
                    userActivity.extendProperties.push(item);
                });
            }
        }
    }
}
